// German translations (Deutsch)
export const de: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Dashboard',
  'menu.orderNew': 'Neue Bestellung',
  'menu.deliveryList': 'Lieferliste',
  'menu.delivery': 'Lieferung',
  'menu.receipt': 'Quittung drucken',
  'menu.carWash': 'Autowäsche',
  'menu.referral': 'Einladen',
  'menu.barber': 'Barbier / Friseur',
  
  // Definitions
  'menu.definitions': 'Definitionen',
  'menu.customers': 'Kunden',
  'menu.products': 'Produktdefinitionen',
  'menu.pricing': 'Preisdefinitionen',
  'menu.tailoring': 'Schneiderei',
  'menu.attributes': 'Produktattribute',
  'menu.users': 'Benutzer',
  'menu.productOrdering': 'Produktreihenfolge',
  'menu.discounts': 'Rabattdefinitionen',
  
  // Settings
  'menu.settings': 'Einstellungen',
  'menu.generalSettings': 'Allgemeine Einstellungen',
  'menu.permissions': 'Rechteverwaltung',
  'menu.subscription': 'Abonnement',
  'menu.invoices': 'Rechnungsverwaltung',
  'menu.expenses': 'Ausgaben',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Berichte & Buchhaltung',
  'menu.systemAndCommunication': 'System & Kommunikation',
  'menu.reportsList': 'Quittungsliste',
  'menu.accountStatement': 'Kontoauszug',
  'reportsList.totalReceipts': 'Gesamte Quittungen',
  'reportsList.registered': 'Registriert',
  'reportsList.delivered': 'Geliefert',
  'reportsList.totalRevenueExclCancelled': 'Gesamtumsatz (ohne Stornierungen)',
  'reportsList.activeOnly': 'Nur aktive Bestellungen',
  'reportsList.receiptNumber': 'Quittung Nr.',
  'reportsList.customer': 'Kunde',
  'reportsList.phone': 'Telefon',
  'reportsList.date': 'Datum',
  'reportsList.amount': 'Betrag',
  'reportsList.status': 'Status',
  'reportsList.payment': 'Zahlung',
  'reportsList.searchPlaceholder': 'Quittung Nr., Kundenname oder Telefon...',
  'reportsList.noOrders': 'Keine Bestellungen gefunden',
  'reportsList.cancelled': 'Storniert',
  'reportsList.reprint': 'Erneut drucken',
  'menu.tickets': 'Support-Anfragen',
  'menu.support': 'Support',
  'menu.profile': 'Profil',
  'menu.logout': 'Abmelden',
  'menu.notifications': 'SMS/WhatsApp-Benachrichtigungen',
  'menu.whatsappConnection': 'WhatsApp-Verbindung',
  'menu.smsConnection': 'SMS-Verbindung',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.todaySales': 'Heutige Verkäufe',
  'dashboard.totalOrders': 'Gesamtbestellungen',
  'dashboard.pendingDeliveries': 'Ausstehende Lieferungen',
  'dashboard.activeCustomers': 'Aktive Kunden',
  'dashboard.recentOrders': 'Letzte Bestellungen',
  'dashboard.viewAll': 'Alle anzeigen',
  'dashboard.quickActions': 'Schnellaktionen',
  'dashboard.newOrder': 'Neue Bestellung',
  'dashboard.newCustomer': 'Neuer Kunde',
  'dashboard.deliveries': 'Lieferungen',
  'dashboard.reports': 'Berichte',
  'dashboard.today': 'Heute',
  'dashboard.yesterday': 'Gestern',
  'dashboard.week': 'Woche',
  'dashboard.month': 'Monat',
  'dashboard.quarter': 'Quartal',
  'dashboard.year': 'Jahr',
  'dashboard.totalRevenue': 'Gesamtumsatz',
  'dashboard.totalPieces': 'Gesamtstücke',
  'dashboard.cancelled': 'Storniert',
  'dashboard.inProcess': 'In Bearbeitung',
  'dashboard.inProcessDesc': 'Bestellungen in Bearbeitung',
  'dashboard.ready': 'Fertig',
  'dashboard.readyDesc': 'Lieferbereit',
  'dashboard.delivered': 'Geliefert',
  'dashboard.deliveredDesc': 'Abgeschlossene Bestellungen',
  'dashboard.announcements': 'Ankündigungen',
  'dashboard.announcementAll': 'Allgemein',
  'dashboard.announcementPrivate': 'Privat',
  
  // Service Types
  'service.tailor': 'Schneiderei',
  'service.dryCleaning': 'Chemische Reinigung',
  'service.washing': 'Waschen',
  'service.ironing': 'Bügeln',
  'service.dyeing': 'Färben',
  'service.shoeShine': 'Schuhputzen',
  'service.carpet': 'Teppich',
  'service.tailoring': 'Schneidereireparatur',
  'service.carpetWashing': 'Teppichreinigung',
  'service.sofaWashing': 'Sofáreinigung',
  'service.carWash': 'Autowäsche & Detailing',
  'service.barber': 'Friseur / Barbier',
  'service.selectService': 'Service auswählen',
  'service.addToCart': 'In den Warenkorb',
  'service.total': 'Gesamt',
  
  // Order Create Page
  'orderCreate.cart': 'Warenkorb',
  'orderCreate.totalPieces': 'Gesamtstücke',
  'orderCreate.plannedDelivery': 'Geplante Lieferung',
  'orderCreate.payment': 'Zahlung',
  'orderCreate.save': 'Speichern',
  'orderCreate.continue': 'Weiter',
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',

  'orderCreate.allCategories': 'Alle',
  'orderCreate.selectCustomer': 'Kunde auswählen',
  'orderCreate.selectCustomerPlaceholder': 'Kunde auswählen',
  'orderCreate.change': 'Ändern',
  'orderCreate.select': 'Auswählen',
  'orderCreate.balance': 'Saldo',
  'orderCreate.searchCustomer': 'Suche nach Name, Telefon oder Adresse... (Beispiel: hans+491234567)',
  'orderCreate.newCustomer': 'Neuer Kunde',
  'orderCreate.customerName': 'Vor- und Nachname',
  'orderCreate.customerPhone': 'Telefon',
  'orderCreate.customerEmail': 'E-Mail',
  'orderCreate.customerAddress': 'Adresse',
  'orderCreate.addCustomer': 'Kunde hinzufügen',
  'orderCreate.customer': 'Kunde',
  'orderCreate.serviceType': 'Servicetyp',
  'orderCreate.clickToSelect': 'Zum Auswählen klicken',
  'orderCreate.deliveryDate': 'Lieferdatum',
  'orderCreate.details': 'Details',
  'orderCreate.itemDetails': 'Artikeldetails',
  'orderCreate.tailoringOperations': 'Schneiderarbeiten',
  'orderCreate.tailoringTitle': 'Schneiderarbeiten',
  'orderCreate.discount': 'Rabatt',
  'orderCreate.discountLabel': 'Rabatt (%)',
  'orderCreate.debt': 'Schuld',
  'orderCreate.credit': 'Guthaben',
  'orderCreate.homeDelivery': 'Hauslieferung',
  'orderCreate.homeDeliveryAddress': 'Adresse',
  'orderCreate.addressRequired': 'Adresse erforderlich!',
  'orderCreate.subtotal': 'Zwischensumme',
  'orderCreate.grandTotal': 'Gesamtsumme',
  
  // Products
  'products.title': 'Produktdefinitionen',
  'products.addNew': 'Neues Produkt',
  'products.category': 'Kategorie',
  'products.name': 'Produktname',
  'products.price': 'Preis',
  'products.color': 'Farbe',
  'products.active': 'Aktiv',
  'products.actions': 'Aktionen',
  'products.search': 'Produkt suchen...',
  'products.noProducts': 'Keine Produkte gefunden',
  'products.noCategoryProducts': 'Keine Produkte in dieser Kategorie gefunden',
  'products.emptyCart': 'Warenkorb ist leer',
  
  // Customers
  'customers.title': 'Kunden',
  'customers.addNew': 'Neuer Kunde',
  'customers.search': 'Kunden suchen...',
  'customers.name': 'Name',
  'customers.phone': 'Telefon',
  'customers.email': 'E-Mail',
  'customers.address': 'Adresse',
  'customers.balance': 'Saldo',
  'customers.actions': 'Aktionen',
  'customers.edit': 'Bearbeiten',
  'customers.delete': 'Löschen',
  'customers.noCustomers': 'Keine Kunden gefunden',
  'customers.tableCustomer': 'Kunde',
  'customers.tableContact': 'Kontakt',
  'customers.tableAddress': 'Adresse',
  'customers.tableNotifications': 'Benachrichtigungen',
  'customers.tableBalance': 'Saldo',
  'customers.tableActions': 'Aktionen',
  'customers.totalCount': 'Insgesamt {count} Kunden',
  'customers.notes': 'Notiz',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Suche nach Name, Telefon, E-Mail oder Adresse... (Beispiel: hans+491234567)',
  'customers.updated': 'Kunde aktualisiert',
  'customers.updateError': 'Kunde konnte nicht aktualisiert werden',
  'customers.added': 'Kunde hinzugefügt',
  'customers.addError': 'Kunde konnte nicht hinzugefügt werden',
  'customers.deleted': 'Kunde gelöscht',
  'customers.deleteError': 'Kunde konnte nicht gelöscht werden',
  'customers.deleteConfirm': 'Möchten Sie den Kunden "{name}" wirklich löschen?',
  'customers.loadError': 'Kunden konnten nicht geladen werden',
  'customers.noResults': 'Keine Ergebnisse gefunden',
  'customers.showingFirst50': 'Zeige erste 50 Ergebnisse',
  'customers.totalResults': 'insgesamt',
  
  // Users
  'users.title': 'Benutzer',
  'users.addNew': 'Neuer Benutzer',
  'users.name': 'Vollständiger Name',
  'users.email': 'E-Mail',
  'users.role': 'Rolle',
  'users.pin': 'PIN',
  'users.permissions': 'Berechtigungen',
  'users.allPermissions': 'Alle Berechtigungen',
  'users.permissionCount': '{count} Berechtigungen',
  'users.changePin': 'PIN ändern',
  'users.edit': 'Bearbeiten',
  'users.newUser': 'Neuer Benutzer',
  'users.editUser': 'Benutzer bearbeiten',
  'users.editingUser': 'Benutzer {name} bearbeiten',
  'users.pinCode': 'PIN-Code (4-6 Ziffern)',
  'users.selectRole': 'Rolle auswählen',
  'users.patron': 'Inhaber',
  'users.kasiyer': 'Kassierer',
  'users.sofor': 'Fahrer',
  'users.eleman': 'Mitarbeiter',
  'users.changePinTitle': 'PIN-Code ändern',
  'users.newPin': 'Neuer PIN-Code',
  'users.confirmPin': 'PIN-Code bestätigen',
  'users.pinMismatch': 'PIN-Codes stimmen nicht überein',
  'users.pinRequired': 'PIN-Code ist erforderlich',
  'users.pinLength': 'PIN-Code muss 4-6 Ziffern lang sein',
  'users.changingPinFor': 'PIN-Code für {name} ändern',
  
  // Pricing Page
  'pricing.title': 'Preisdefinitionen',
  'pricing.search': 'Produkt suchen...',
  'pricing.product': 'Produkt',
  'pricing.dryCleaning': 'Chemische Reinigung',
  'pricing.washing': 'Waschen',
  'pricing.ironing': 'Bügeln',
  'pricing.dyeing': 'Färben',
  'pricing.tailoring': 'Schneidereireparatur',
  'pricing.shoeShine': 'Schuhputzen',
  'pricing.action': 'Aktion',
  'pricing.save': 'Speichern',
  'pricing.saving': 'Speichern',
  'pricing.pricesSaved': 'Preise gespeichert',
  'pricing.pricesSaveError': 'Preise konnten nicht gespeichert werden',
  'pricing.noProducts': 'Keine Produkte gefunden',
  'pricing.loadError': 'Produkte konnten nicht geladen werden',
  
  // Tailoring Page
  'tailoring.title': 'Schneiderarbeiten',
  'tailoring.addNew': 'Neue Operation',
  
  // Attributes Page
  'attributes.title': 'Produktattribute',
  'attributes.colors': 'Farben',
  'attributes.stains': 'Fleckentypen',
  'attributes.damages': 'Schadenstypen',
  'attributes.add': 'Hinzufügen',
  
  // Permissions Page
  'permissions.title': 'Rechteverwaltung',
  'permissions.subtitle': 'Berechtigungen für Inhaber- und Kassiererrollen festlegen',
  'permissions.about': 'Über Rechteverwaltung',
  'permissions.patronInfo': '<strong>Inhaber:</strong> Hauptadministratorrolle mit allen Systemberechtigungen.',
  'permissions.cashierInfo': '<strong>Kassierer:</strong> Benutzerrolle mit eingeschränkten Berechtigungen für tägliche Vorgänge.',
  'permissions.saveSuccess': 'Berechtigungen gespeichert',
  'permissions.saveError': 'Berechtigungen konnten nicht gespeichert werden',
  'permissions.patron': 'Inhaber',
  'permissions.cashier': 'Kassierer',
  'permissions.patronRole': 'Vollständiger Administratorzugriff',
  'permissions.cashierRole': 'Eingeschränkter Benutzerzugriff',
  'permissions.activePermissions': 'Aktive Berechtigungen:',
  'permissions.selectAllPatron': 'Alle für Inhaber auswählen',
  'permissions.deselectAllPatron': 'Alle für Inhaber abwählen',
  'permissions.selectAllCashier': 'Alle für Kassierer auswählen',
  'permissions.deselectAllCashier': 'Alle für Kassierer abwählen',
  'permissions.saving': 'Speichern...',
  'permissions.permissionList': 'Berechtigungsliste',
  'permissions.infoTitle': 'Über Rechteverwaltung',
  'permissions.infoText1': 'Hauptadministratorrolle mit allen Systemberechtigungen.',
  'permissions.infoText2': 'Benutzerrolle mit eingeschränkten Berechtigungen für tägliche Vorgänge.',
  'permissions.infoText3': 'Änderungen werden erst nach dem Speichern wirksam.',
  'permissions.infoText4': 'Berechtigungen können für jede Rolle angepasst werden.',
  
  // Driver Dashboard Page
  'driver.title': 'Fahrer-Dashboard',
  'driver.todayRevenue': 'Heutiger Umsatz',
  'driver.totalPieces': 'Gesamtstücke',
  'driver.pending': 'Ausstehend',
  'driver.ready': 'Fertig',
  'driver.pickup': 'Abholung',
  'driver.delivery': 'Lieferung',
  
  // Subscription Page
  'subscription.title': 'Abonnementpläne',
  'subscription.currentPlan': 'Ihr aktueller Plan',
  'subscription.upgradePlan': 'Upgrade',
  'subscription.downgradePlan': 'Downgrade',
  'subscription.choosePlan': 'Plan wählen',
  'subscription.billingCycle': 'Abrechnungszyklus',
  'subscription.monthly': 'Monatlich',
  'subscription.yearly': 'Jährlich',
  'subscription.perMonth': '/Monat',
  'subscription.perYear': '/Jahr',
  'subscription.plusVAT': '+ MwSt.',
  'subscription.save': '{percent}% sparen',
  'subscription.mostPopular': 'Beliebteste',
  'subscription.freeTrial': '{months} Monat kostenlos',
  'subscription.featuresIncluded': 'Enthaltene Funktionen:',
  
  // Plan Names & Descriptions
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Perfekt für kleine Unternehmen',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Für wachsende Unternehmen',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Unternehmenslösungen',
  
  // Plan Features
  'subscription.maxReceipts': 'Maximal {count} Belege/Monat',
  'subscription.maxUsers': '{count} Benutzerkonten',
  'subscription.whatsappCredits': '🎁 {count} WhatsApp-Credits geschenkt',
  'subscription.basicReports': 'Grundlegende Berichte',
  'subscription.advancedReports': 'Erweiterte Berichte',
  'subscription.customReports': 'Benutzerdefinierte Berichte',
  'subscription.whatsappIntegration': 'WhatsApp-Integration',
  'subscription.supportTicket': 'Support-Ticket-Antwortzeit: {hours} Stunden',
  'subscription.supportTicketBusiness': 'Support-Ticket-Antwortzeit: {hours} Stunden (Geschäftszeiten)',
  'subscription.accountManagement': 'Kontoverwaltung',
  'subscription.driverApp': 'Mobile Fahrer-App',
  'subscription.prioritySupport': 'Prioritäts-Support',
  'subscription.managerApp': 'Mobile App - Manager-Ansicht',
  
  // Payment
  'subscription.paymentTitle': 'Zahlung abschließen',
  'subscription.planSelection': 'Ausgewählter Plan',
  'subscription.billingPeriod': 'Abrechnungszeitraum',
  'subscription.month': 'Monat',
  'subscription.year': 'Jahr',
  'subscription.subtotal': 'Zwischensumme',
  'subscription.tax': 'MwSt. ({rate}%)',
  'subscription.total': 'Gesamt',
  'subscription.couponCode': 'Gutscheincode',
  'subscription.applyCoupon': 'Anwenden',
  'subscription.removeCoupon': 'Entfernen',
  'subscription.discount': 'Rabatt',
  'subscription.invalidCoupon': 'Ungültiger Gutscheincode',
  'subscription.couponVerificationFailed': 'Gutschein-Überprüfung fehlgeschlagen',
  'subscription.couponRemoved': 'Gutschein entfernt',
  
  // Billing Information
  'subscription.billingInfo': 'Rechnungsinformationen',
  'subscription.companyName': 'Firmenname',
  'subscription.companyNamePlaceholder': 'Firmenname eingeben',
  'subscription.taxNumber': 'Steuernummer',
  'subscription.taxNumberPlaceholder': 'Steuernummer eingeben',
  'subscription.phone': 'Telefon',
  'subscription.phonePlaceholder': 'Telefonnummer eingeben',
  'subscription.address': 'Adresse',
  'subscription.addressPlaceholder': 'Rechnungsadresse eingeben',
  'subscription.corporateInvoice': 'Firmenrechnung',
  'subscription.individualInvoice': 'Einzelrechnung',
  
  // Payment Methods
  'subscription.paymentMethod': 'Zahlungsmethode',
  'subscription.creditCard': 'Kreditkarte',
  'subscription.bankTransfer': 'Banküberweisung',
  'subscription.cardNumber': 'Kartennummer',
  'subscription.cardNumberPlaceholder': 'Kartennummer eingeben',
  'subscription.expiryDate': 'Ablaufdatum',
  'subscription.cvc': 'CVC',
  
  // Actions & Messages
  'subscription.completePayment': 'Zahlung abschließen',
  'subscription.processing': 'Wird verarbeitet...',
  'subscription.redirectingToPayment': 'Weiterleitung zur Zahlungsseite...',
  'subscription.paymentSuccess': '✅ Zahlung erfolgreich! Ihr Abonnement wurde aktiviert.',
  'subscription.paymentCompleted': '🎉 Zahlung erfolgreich abgeschlossen!',
  'subscription.paymentCancelled': '❌ Zahlung storniert.',
  'subscription.paddleTestCards': 'Paddle-Testkarten in der Konsole ausgegeben! (F12)',
  'subscription.sandboxTestCards': '🎴 TESTKARTEN (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ ERFOLGREICHE ZAHLUNGSTESTKARTEN:',
  'subscription.failedPaymentCards': '❌ FEHLGESCHLAGENE ZAHLUNGSTESTKARTEN:',
  'subscription.invalidCard': '📌 Ungültige Karte:',
  'subscription.sandboxOnly': '📝 HINWEIS: Diese Karten funktionieren nur in der Sandbox-Umgebung!',
  
  // Errors
  'subscription.enterCompanyName': 'Firmenname eingeben',
  'subscription.enterPhone': 'Telefonnummer eingeben',
  'subscription.enterTaxNumber': 'Steuernummer eingeben',
  'subscription.selectPackage': 'Bitte wählen Sie ein Paket',
  'subscription.selectPlan': 'Bitte wählen Sie einen Plan',
  'subscription.paddleNotLoaded': 'Paddle SDK noch nicht geladen. Bitte Seite neu laden.',
  'subscription.paymentError': 'Zahlungsfehler: ',
  'subscription.paymentCreationFailed': 'Zahlung konnte nicht erstellt werden. Bitte prüfen Sie die Konsolenprotokolle.',
  'subscription.paddleConfigurationMissing': '⚠️ Paddle-Konfiguration fehlt!',
  'subscription.paddleDashboardRequired': '⚠️ Paddle Dashboard-Konfiguration erforderlich!',
  'subscription.paddleApiNotConfigured': 'Paddle-API-Schlüssel nicht konfiguriert. Bitte wenden Sie sich an Ihren Administrator.',
  
  // Cancel Subscription
  'subscription.cancelConfirm': 'Möchten Sie Ihr Abonnement wirklich kündigen? Ihr Service wird bis zum Ende des Abrechnungszeitraums fortgesetzt.',
  'subscription.cancelSuccess': '✅ Abonnement gekündigt. Ihr Service wird bis zum Ende des Abrechnungszeitraums fortgesetzt.',
  'subscription.cancelFailed': 'Kündigung fehlgeschlagen',
  
  // Region & Currency
  'subscription.region.turkey': '🇹🇷 Türkei',
  'subscription.region.europe': '🇪🇺 Europa',
  'subscription.region.other': '🌎 Andere',
  
  // Status
  'subscription.status': 'Status',
  'subscription.active': 'Aktiv',
  'subscription.sandboxMode': '🧪 SANDBOX (Testmodus)',
  'subscription.liveMode': '🚀 LIVE (Produktionsumgebung)',
  'subscription.paddleActive': 'Aktiv',
  'subscription.paddleConfigured': '✅ Ja',
  'subscription.paddleNotConfigured': '❌ Nein',
  
  // WhatsApp Credits
  'subscription.whatsappCreditsTitle': 'WhatsApp-Credits',
  'subscription.whatsappCreditsPackages': 'Credit-Pakete',
  'subscription.whatsappCurrentBalance': 'Aktueller Saldo',
  'subscription.whatsappCreditsAmount': '{count} Credits',
  'subscription.whatsappPurchaseCredits': 'Credits kaufen',
  
  // Invoices Page
  'invoices.title': 'Rechnungsverwaltung',
  'invoices.subtitle': 'Abonnementrechnungen anzeigen und herunterladen',
  
  // Common Form Fields
  'form.color': 'Farbe',
  'form.stain': 'Fleck',
  'form.damage': 'Schaden',
  'form.notes': 'Notizen',
  'form.area': 'Bereich',
  
  // Stain Types
  'stain.blood': 'Blut',
  'stain.oil': 'Öl',
  'stain.ink': 'Tinte',
  'stain.teaCoffee': 'Tee/Kaffee',
  'stain.fruit': 'Frucht',
  'stain.rust': 'Rost',
  'stain.paint': 'Farbe',
  'stain.mud': 'Schlamm',
  'stain.salt': 'Salz',
  'stain.none': 'Keine',
  'stain.status': 'Fleckstatus',
  'stain.multiple': 'Fleckstatus (Mehrfachauswahl)',
  'stain.other': 'Andere Fleckenart (Enter drücken zum Hinzufügen)...',
  
  // Expenses Page
  'expenses.title': 'Ausgabeneingabe',
  'expenses.addNew': 'Neue Ausgabe',
  'expenses.total': 'Gesamtausgaben',
  'expenses.totalToday': 'Heutige Gesamtausgaben',
  'expenses.deletePermission': 'ℹ️ Löschen von Ausgaben ist nur für die Inhaberrolle autorisiert.',
  'expenses.description': 'Beschreibung',
  'expenses.amount': 'Betrag',
  'expenses.category': 'Kategorie',
  'expenses.noExpenses': 'Heute keine Ausgaben',
  'expenses.newExpense': 'Neue Ausgabe',
  'expenses.descriptionLabel': 'Beschreibung *',
  'expenses.amountLabel': 'Betrag (€) *',
  'expenses.categoryLabel': 'Kategorie *',
  'expenses.categoryPlaceholder': 'Kategorie auswählen...',
  'expenses.deleteTitle': 'Ausgabe löschen',
  'expenses.deleteConfirm': 'Möchten Sie diese Ausgabe wirklich löschen?',
  'expenses.descriptionField': 'Beschreibung:',
  'expenses.categoryField': 'Kategorie:',
  'expenses.amountField': 'Betrag:',
  'expenses.dateField': 'Datum:',
  'expenses.cancel': 'Abbrechen',
  'expenses.yesDelete': 'Ja, löschen',
  'expenses.deleting': 'Löschen...',
  'expenses.saved': 'Ausgabe gespeichert',
  'expenses.saveError': 'Ausgabe konnte nicht gespeichert werden',
  'expenses.deleted': 'Ausgabe gelöscht',
  'expenses.deleteError': 'Ausgabe konnte nicht gelöscht werden',
  'expenses.loadError': 'Ausgaben konnten nicht geladen werden',
  'expenses.dateFilter': 'Datumsfilter',
  'expenses.showDateFilter': 'Datumsbereich auswählen',
  'expenses.startDate': 'Startdatum',
  'expenses.endDate': 'Enddatum',
  'expenses.applyFilter': 'Filtern',
  'expenses.clearFilter': 'Löschen',
  'expenses.activeFilter': 'Aktiver Filter',
  'expenses.filterApplied': 'Datumsfilter angewendet',
  'expenses.filterCleared': 'Filter gelöscht',
  'expenses.selectBothDates': 'Bitte wählen Sie sowohl Start- als auch Enddatum',
  'expenses.canOnlyDeleteToday': 'Sie können nur die heute eingegebenen Ausgaben löschen.',
  'expenses.myBranch': 'Meine Filiale',
  'expenses.noBranchSelected': '— Keine Filiale ausgewählt —',
  'expenses.branchSelect': 'Filiale auswählen',
  'expenses.excelError': 'Excel-Datei konnte nicht erstellt werden',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'Einträge',
  'expenses.categoryBy': 'Nach Kategorie',
  'expenses.allTypes': 'Alle Typen',
  'expenses.noBranch': 'Keine Filiale',
  'expenses.allBranches': 'Alle Filialen',
  'expenses.expenseType': 'Ausgabentyp',
  
  // Delivery List Page
  'deliveryList.title': 'Lieferliste',
  'deliveryList.search': 'Quittungsnummer, Kundenname oder Telefon...',
  'deliveryList.all': 'Alle',
  'deliveryList.pending': 'Ausstehend',
  'deliveryList.ready': 'Fertig',
  'deliveryList.date': 'Datum',
  'deliveryList.pieces': 'Stücke',
  'deliveryList.amount': 'Betrag',
  'deliveryList.readyButton': 'Fertig',
  'deliveryList.receiptButton': 'Quittung',
  'deliveryList.noOrders': 'Keine Bestellungen gefunden',
  'deliveryList.statusUpdated': 'Bestellung als fertig markiert',
  'deliveryList.statusUpdateError': 'Status konnte nicht aktualisiert werden',
  'deliveryList.loadError': 'Bestellungen konnten nicht geladen werden',
  'deliveryList.whatsappSending': '📱 WhatsApp-Nachricht wird gesendet...',
  'deliveryList.smsSent': '📨 SMS-Nachricht gesendet',
  
  // Delivery Page
  'deliveryPage.title': 'Lieferung',
  'deliveryPage.search': 'Suche nach Quittungsnr., Name, Telefon oder Adresse...',
  'deliveryPage.pieces': 'Stücke',
  'deliveryPage.amount': 'Betrag',
  'deliveryPage.payment': 'Zahlung',
  'deliveryPage.deliverButton': 'Liefern',
  'deliveryPage.noOrdersFound': 'Keine fertigen Bestellungen gefunden',
  'deliveryPage.noReadyOrders': 'Keine lieferbereiten Bestellungen',
  'deliveryPage.minSearchLength': 'Geben Sie mindestens 3 Zeichen ein',
  'deliveryPage.paymentDialogTitle': 'Zahlung bei Lieferung',
  'deliveryPage.ordersLoadError': 'Bestellungen konnten nicht geladen werden',
  'deliveryPage.searchError': 'Suche fehlgeschlagen',
  'deliveryPage.deliverySuccess': 'Bestellung erfolgreich geliefert',
  'deliveryPage.deliveryError': 'Lieferung fehlgeschlagen',
  'deliveryPage.whatsappSending': '📱 Quittung wird per WhatsApp gesendet...',
  'deliveryPage.statusNotReady': 'Bestellung gefunden, aber nicht lieferbereit',
  'deliveryPage.statusPending': 'Ausstehend - Bitte zuerst auf der Seite "Lieferliste" als fertig markieren',
  'deliveryPage.statusDelivered': 'Geliefert',
  'deliveryPage.statusCancelled': 'Storniert',
  'deliveryPage.receiptDelivered': '✅ *GELIEFERT*',
  'deliveryPage.showItems': 'Artikel Anzeigen',
  'deliveryPage.itemsList': 'Bestelldetails',
  'deliveryPage.unknownProduct': 'Unbekanntes Produkt',
  
  // Receipt Page
  'receipt.title': 'Quittung & Etikett',
  'receipt.customerReceipt': 'Kundenquittung',
  'receipt.back': 'Zurück',
  'receipt.print': 'Quittung drucken',
  'receipt.whatsappSend': 'WhatsApp senden',
  'receipt.receiptNumber': 'Quittungsnr.',
  'receipt.date': 'Datum',
  'receipt.time': 'Zeit',
  'receipt.product': 'Produkt',
  'receipt.quantity': 'Menge',
  'receipt.price': 'Preis',
  'receipt.totalPieces': 'Gesamtstücke',
  'receipt.subtotal': 'Zwischensumme',
  'receipt.tax': 'MwSt.',
  'receipt.total': 'GESAMT',
  'receipt.payment': 'Zahlung',
  'receipt.plannedDelivery': 'Geplante Lieferung',
  'receipt.notFound': 'Quittung nicht gefunden',
  'receipt.newOrder': 'Neue Bestellung',
  'receipt.search': 'Quittung suchen und erneut drucken',
  'receipt.searchPlaceholder': 'Suche nach Quittungsnr., Kundenname oder Telefon...',
  'receipt.searchEmpty': 'Geben Sie Quittungsnr. oder Kundenname ein',
  'receipt.noResults': 'Keine Ergebnisse gefunden',
  'receipt.resultsCount': '{count} Ergebnisse gefunden',
  'receipt.printButton': 'Quittung drucken',
  'receipt.products': 'Produkte',
  'receipt.loadError': 'Daten konnten nicht geladen werden',
  'receipt.whatsappOpening': 'WhatsApp wird geöffnet...',
  'receipt.labelPrinting': 'Etikett {current}/{total} wird gedruckt...',
  'receipt.andLabel': 'und Etikett',
  'receipt.stain': 'Fleck',
  'receipt.damage': 'Schaden',
  'receipt.taxPercent': 'MwSt. (20%)',
  'receipt.thankYou': 'Vielen Dank!',

  // Payment Methods
  'order.cash': 'Bargeld',
  'order.card': 'Kreditkarte',
  'order.credit': 'Auf Kredit',
  'order.amountPaid': 'Gezahlter Betrag',
  'order.remainingBalance': 'Verbleibender Saldo',
  
  // Settings Page
  'settings.title': 'Einstellungen',
  'settings.general': 'Allgemeine Einstellungen',
  'settings.companyName': 'Firmenname',
  'settings.language': 'Sprache',
  'settings.currency': 'Währung',
  'settings.currencyPosition': 'Währungsposition',
  'settings.currencyPositionLeft': 'Links (€100,00)',
  'settings.currencyPositionRight': 'Rechts (100,00€)',
  'settings.currencyPositionPreviewLeft': 'Symbol links',
  'settings.currencyPositionPreviewRight': 'Symbol rechts',
  'settings.numberFormat': 'Zahlenformat',
  'settings.currencyFormat': 'Währungsformat',
  'settings.showDecimals': 'Dezimalzahlen anzeigen',
  'settings.showDecimalsDesc': 'Dezimalteil (Cent) in Preisen anzeigen',
  'settings.dateFormat': 'Datumsformat',
  'settings.timezone': 'Zeitzone',
  'settings.deliveryDays': 'Lieferzeit (Tage)',
  'settings.workOnSunday': 'Sonntags arbeiten',
  'settings.defaultServiceType': 'Standard-Servicetyp',
  'settings.defaultServiceTypeDesc': 'Der Servicetyp, der beim Öffnen des Produkteingabebildschirms automatisch ausgewählt wird',
  'settings.defaultCategory': 'Standardkategorie',
  'settings.defaultCategoryDesc': 'Die Kategorie, die beim Öffnen des Produkteingabebildschirms automatisch ausgewählt wird',
  'settings.companyLogo': 'Firmenlogo',
  'settings.logoDescription': 'Das Logo wird auf Quittungen und oben links im Programm angezeigt. Empfohlene Größe: 200x80px',
  'settings.uploadLogo': 'Logo hochladen',
  'settings.removeLogo': 'Logo entfernen',
  'settings.noLogo': 'Kein Logo',
  'settings.receiptSettings': 'Quittungseinstellungen',
  'settings.taxRate': 'Steuersatz (%)',
  'settings.receiptFooterText': 'Quittungsfußzeilentext',
  'settings.receiptNote': 'Quittungsfußzeile (Notizen)',
  'settings.socialMedia': 'Soziale Medien & Kontakt',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Website',
  'settings.phone': 'Telefon',
  'settings.address': 'Adresse',
  'settings.dangerZone': 'Gefahrenzone',
  'settings.deleteDemoDataWarning': 'Entfernt die bei der Einrichtung automatisch angelegten Beispielkunden samt ihren Belegen und Zahlungen. Selbst angelegte Kunden und Belege werden nicht gelöscht.',
  'settings.productsWillBeKept': 'Produktdefinitionen bleiben erhalten.',
  'settings.deleteDemoDataTitle': 'Demodaten werden gelöscht',
  'settings.deleteDemoDataConfirm': 'Dies kann nicht rückgängig gemacht werden! Die Beispielkunden und ihre Belege/Zahlungen werden gelöscht; Ihre eigenen Kunden und Belege bleiben erhalten.',
  'toast.noDemoData': 'Keine Beispielkunden zum Löschen gefunden.',
  'toast.demoCustomersKept': '{n} Beispielkunde(n) behalten, da Sie Belege für sie erstellt haben; nur die Beispielbelege wurden gelöscht.',
  'settings.areYouSure': 'Möchten Sie wirklich fortfahren?',
  'settings.deleting': 'Löschen...',
  'settings.yesDelete': 'Ja, löschen',
  'settings.deleteDemoData': 'Demodaten löschen',
  'settings.save': 'Speichern',
  'settings.loading': 'Laden...',
  
  // Toasts
  'toast.settingsSaved': 'Einstellungen gespeichert',
  'toast.settingsError': 'Einstellungen konnten nicht gespeichert werden',
  'toast.settingsLoadError': 'Einstellungen konnten nicht geladen werden',
  'toast.logoUploaded': 'Logo hochgeladen. Vergessen Sie nicht zu speichern!',
  'toast.logoRemoved': 'Logo entfernt. Vergessen Sie nicht zu speichern!',
  'toast.logoSizeError': 'Logo-Datei muss kleiner als 500 KB sein',
  'toast.logoTypeError': 'Es können nur Bilddateien hochgeladen werden',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'WhatsApp-Verbindung',
  'whatsapp.subtitle': 'WhatsApp Business API-Verbindung verwalten',
  'whatsapp.connectionStatus': 'Verbindungsstatus',
  'whatsapp.disconnected': 'Getrennt',
  'whatsapp.notConnectedMessage': 'Ihr WhatsApp-Konto ist noch nicht verbunden',
  'whatsapp.connectWithQR': 'Mit QR-Code verbinden',
  'whatsapp.importantInfo': 'Wichtige Informationen',
  'whatsapp.info1': '1. Scannen Sie den QR-Code mit der WhatsApp-Anwendung Ihres Telefons',
  'whatsapp.info2': '2. Nach der Verbindung können Sie automatische Nachrichten senden',
  'whatsapp.info3': '3. Zum Trennen melden Sie sich in den WhatsApp-Einstellungen ab',
  'whatsapp.info4': '4. QR-Code wird automatisch nach 60 Sekunden aktualisiert',
  'whatsapp.generateQR': 'QR-Code generieren',
  
  // Common
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.save': 'Speichern',
  'common.search': 'Suchen',
  'common.loading': 'Laden...',
  'common.noData': 'Keine Daten',
  'common.actions': 'Aktionen',
  'common.status': 'Status',
  'common.date': 'Datum',
  'common.time': 'Zeit',
  'common.total': 'Gesamt',
  'common.close': 'Schließen',
  'common.back': 'Zurück',
  'common.submit': 'Senden',
  'common.create': 'Erstellen',
  'common.creating': 'Erstellen...',
  'common.later': 'Später',
  
  // Tickets
  'tickets.title': 'Support-Anfragen',
  'tickets.newTicket': 'Neue Anfrage',
  'tickets.noTickets': 'Noch keine Support-Anfragen',
  'tickets.noTicketsDesc': 'Wenn Sie ein Problem haben, können Sie eine neue Support-Anfrage erstellen',
  'tickets.subject': 'Betreff',
  'tickets.description': 'Beschreibung',
  'tickets.yourName': 'Ihr Name',
  'tickets.yourNamePlaceholder': 'Geben Sie Ihren Namen ein',
  'tickets.subjectPlaceholder': 'Fassen Sie Ihr Problem kurz zusammen',
  'tickets.descriptionPlaceholder': 'Beschreiben Sie Ihr Problem im Detail',
  'tickets.created': 'Support-Anfrage erstellt',
  'tickets.createError': 'Support-Anfrage konnte nicht erstellt werden',
  'tickets.fillAllFields': 'Alle Felder ausfüllen',
  'tickets.loadError': 'Anfragen konnten nicht geladen werden',
  'tickets.messages': 'Nachrichten',
  'tickets.status.open': 'Offen',
  'tickets.status.investigating': 'In Bearbeitung',
  'tickets.status.waitingCustomer': 'Warten auf Kunden',
  'tickets.status.closed': 'Gelöst',
  'tickets.conversation': 'Unterhaltung',
  'tickets.admin': 'Support-Team',
  'tickets.typeMessage': 'Geben Sie Ihre Nachricht ein...',
  'tickets.sendError': 'Nachricht konnte nicht gesendet werden',
  'tickets.closedMessage': 'Diese Anfrage wurde als gelöst markiert.',
  'tickets.rateSupport': 'Support bewerten',
  'tickets.rateExperience': 'Bewerten Sie Ihre Erfahrung',
  'tickets.rateDescription': 'Wie würden Sie den erhaltenen Support bewerten?',
  'tickets.selectRating': 'Bitte wählen Sie eine Bewertung',
  'tickets.ratingSubmitted': 'Ihre Bewertung wurde gespeichert, vielen Dank!',
  'tickets.ratingError': 'Bewertung konnte nicht übermittelt werden',
  'tickets.yourRating': 'Ihre Bewertung',
  'tickets.rating.veryBad': 'Sehr schlecht',
  'tickets.rating.bad': 'Schlecht',
  'tickets.rating.okay': 'Okay',
  'tickets.rating.good': 'Gut',
  'tickets.rating.excellent': 'Ausgezeichnet',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Reinigungsverwaltungssystem',
  'login.tenantId': 'Firmen-ID',
  'login.tenantPlaceholder': 'firmen-id (z.B.: acme-clean)',
  'login.tenantIdHelp': 'Geben Sie Ihre eindeutige Firmenkennung ein',
  'login.continue': 'Weiter →',
  'login.notMember': 'Noch kein Mitglied?',
  'login.startTrial': 'Kostenlose Testversion starten',
  'login.adminLogin': '🔒 Admin-Anmeldung',
  'login.enterPin': 'Geben Sie Ihren PIN-Code ein',
  'login.changeTenant': 'Firma wechseln',
  'login.clear': 'Löschen',
  'login.delete': 'Löschen',
  'login.login': 'Anmelden',
  'login.loggingIn': 'Anmeldung...',
  'login.defaultPinOwner': 'Standard-PIN: <strong>1234</strong> (Inhaber)',
  'login.defaultPinCashier': 'Standard-PIN: <strong>0000</strong> (Kassierer)',
  'login.systemInitializing': 'System wird initialisiert...',
  'login.pinMinLength': 'PIN muss mindestens 4 Ziffern lang sein',
  'login.invalidTenantId': 'Geben Sie eine gültige Firmen-ID ein',
  'login.tenantNotFound': 'Dieser Firmencode wurde nicht gefunden. Bitte überprüfen Sie oder erstellen Sie ein neues Konto.',
  'login.loginFailed': 'Anmeldung fehlgeschlagen',
  'login.welcome': 'Willkommen, {name}',

  // Signup translations
  'signup.title': 'Kostenlose Testversion starten',
  'signup.subtitle': '15 Tage kostenlos testen, keine Kreditkarte erforderlich',
  'signup.backToLogin': 'Zurück zur Anmeldung',
  'signup.companyCode': 'Firmencode',
  'signup.companyCodePlaceholder': 'z.B.: cleanpro',
  'signup.companyCodeHelp': 'Dieser Code wird für die Systemanmeldung verwendet',
  'signup.companyCodeMinLength': 'Firmencode muss mindestens 3 Zeichen lang sein',
  'signup.companyName': 'Firmenname',
  'signup.companyNamePlaceholder': 'Ihr Firmenname',
  'signup.companyNameRequired': 'Firmenname ist erforderlich',
  'signup.fullName': 'Vollständiger Name',
  'signup.fullNamePlaceholder': 'Ihr vollständiger Name',
  'signup.fullNameRequired': 'Vollständiger Name ist erforderlich',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+49 151 123 4567',
  'signup.validPhoneRequired': 'Bitte geben Sie eine gültige Telefonnummer ein',
  'signup.email': 'E-Mail',
  'signup.emailPlaceholder': 'beispiel@firma.de',
  'signup.validEmailRequired': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'signup.createAccount': 'Konto erstellen',
  'signup.creating': 'Erstellen...',
  'signup.terms': 'Mit der Erstellung eines Kontos stimmen Sie unseren Nutzungsbedingungen und Datenschutzrichtlinien zu.',
  'signup.success': 'Registrierung erfolgreich! Anmeldedaten wurden an Ihre E-Mail gesendet.',
  'signup.successTitle': 'Registrierung erfolgreich!',
  'signup.successMessage': 'Ihr Konto wurde erfolgreich erstellt.',
  'signup.emailSent': 'Anmeldedaten wurden an Ihre E-Mail gesendet.',
  'signup.redirecting': 'Weiterleitung zur Anmeldeseite...',
  'signup.startupPackageLoaded': 'Startpaket geladen!',
  'signup.products': 'Produkt',
  'signup.customers': 'Kunde',
  'signup.users': 'Benutzer',
  'signup.demoDataReady': '✨ Ihre Demodaten sind bereit, Sie können sofort beginnen!',
  'signup.loginInfo': '📧 Ihre Anmeldedaten',
  'signup.loginInfoSent': '💡 Diese Anmeldedaten wurden auch an Ihre E-Mail gesendet',
'signup.loginNow': 'Jetzt anmelden →',
  'signup.hints.companyCode': 'Wird für Anmeldung verwendet',
  'signup.hints.country': 'Ihr Land wurde automatisch erkannt. Sie können ein anderes Land auswählen.',
  'signup.freeTrial': '🎉 15 Tage kostenlos testen - Keine Kreditkarte erforderlich!',
  'signup.businessType.question': 'Was für ein Unternehmen haben Sie?',
  'signup.businessType.hint': 'Ihr Standardbildschirm wird automatisch entsprechend Ihrer Auswahl eingestellt',
  'signup.businessType.continue': 'Weiter',
  'signup.bt.dryCleaning.desc': 'Reinigung von Kleidung, Vorhängen und Textilien',
  'signup.bt.carpetWashing.desc': 'Reinigung von Teppichen, Kilims und Läufern',
  'signup.bt.shoeShine.desc': 'Schuhpflege und -reinigung',
  'signup.bt.sofaWashing.desc': 'Reinigung von Sofas, Sesseln und Couchgarnituren',
  'signup.bt.carWash.desc': 'Fahrzeugwäsche, Politur und Pflege',
  'signup.bt.tailoring.desc': 'Schneiderei, Änderungen und Nähservice',
  'signup.bt.barber.desc': 'Friseur, Barbier und Schönheitssalon',
  'signup.bt.tailoring.desc': 'Schneiderei, Änderungen und Näharbeiten',
  'signup.bt.barber.desc': 'Friseur, Barbier und Schönheitssalon',

  // Account Statement Page
  'accountStatement.title': 'Kontoauszug',
  'accountStatement.subtitle': 'Kundenbasierte Forderungsverfolgung',
  'accountStatement.selectCustomer': 'Kunde auswählen',
  'accountStatement.customerPlaceholder': 'Kunde auswählen...',
  'accountStatement.searchCustomer': 'Nach Name, Telefon oder Adresse suchen...',
  'accountStatement.noCustomerSelected': 'Bitte wählen Sie einen Kunden',
  'accountStatement.currentBalance': 'Aktueller Saldo',
  'accountStatement.totalDebt': 'Gesamtschuld',
  'accountStatement.totalPayments': 'Gesamtzahlungen',
  'accountStatement.transactions': 'Transaktionen',
  'accountStatement.noTransactions': 'Keine Transaktionsaufzeichnungen für diesen Kunden gefunden',
  'accountStatement.date': 'Datum',
  'accountStatement.description': 'Beschreibung',
  'accountStatement.debit': 'Soll',
  'accountStatement.credit': 'Haben',
  'accountStatement.balance': 'Saldo',
  'accountStatement.order': 'Bestellung',
  'accountStatement.payment': 'Zahlung',
  'accountStatement.loadError': 'Kontoauszug konnte nicht geladen werden',
  'accountStatement.addPayment': 'Zahlung hinzufügen',
  'accountStatement.paymentAmount': 'Zahlungsbetrag',
  'accountStatement.paymentMethod': 'Zahlungsmethode',
  'accountStatement.paymentNotes': 'Notizen (Optional)',
  'accountStatement.recordPayment': 'Zahlung erfassen',
  'accountStatement.paymentSaved': 'Zahlung erfasst',
  'accountStatement.paymentError': 'Zahlung konnte nicht erfasst werden',
  'accountStatement.selectCustomerFirst': 'Bitte wählen Sie zuerst einen Kunden',
  'accountStatement.exportStatement': 'Auszug exportieren',
  'accountStatement.exportStatementPDF': 'PDF herunterladen',
  'accountStatement.noCustomersFound': 'Keine Kunden gefunden',
  'accountStatement.searchHint': 'Geben Sie mindestens 2 Zeichen ein, um Kunden zu suchen',
  'accountStatement.selectedCustomer': 'Ausgewählter Kunde',
  'accountStatement.changeCustomer': 'Kunde wechseln',
  
  // Toast Messages
  'toast.usernameRequired': 'Benutzername ist erforderlich',
  'toast.firstLoginChangePin': '⚠️ Erste Anmeldung - Bitte ändern Sie Ihren PIN-Code',
  'toast.tenantNotFound': 'Firma nicht gefunden: "{tenantId}"\\n\\nBitte klicken Sie auf "Kostenlose Testversion starten", um ein neues Firmenkonto zu erstellen.',
  'toast.tenantIdNotRemembered': '🗑️ Firmen-ID wird nicht gespeichert',
  'toast.demoDataLoaded': 'Demo-Benutzer, Produkte, Kunden und Bestellungen wurden erstellt!',
  
  'toast.productsLoadError': 'Fehler beim Laden der Produkte',
  'toast.statsLoadError': 'Fehler beim Laden der Statistiken',
  'toast.orderDetailsLoadError': 'Fehler beim Laden der Bestelldetails',
  'toast.orderLoadError': 'Fehler beim Laden der Bestellung',
  'toast.customerExistingSelected': 'Bestehender Kunde ausgewählt',
  'toast.paymentFailedTryAgain': 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'toast.paymentStatusCheckFailed': 'Zahlungsstatus konnte nicht überprüft werden.',
  'toast.customerPhoneNotFound': 'Telefonnummer des Kunden nicht gefunden',
  'toast.whatsappSent': 'WhatsApp-Nachricht gesendet! ✅',
  'toast.whatsappFailed': 'WhatsApp-Nachricht konnte nicht gesendet werden',
  'toast.orderUpdateError': 'Fehler beim Aktualisieren der Bestellung',
  'toast.searchError': 'Suchfehler',
  'toast.orderNotFound': 'Bestellung nicht gefunden',
  'toast.editCancelled': 'Bearbeitung abgebrochen',
  'toast.noEditPermission': 'Sie haben keine Berechtigung, vergangene Bestellungen zu bearbeiten',
  'toast.selectAtLeastOneOperation': 'Bitte wählen Sie mindestens einen Vorgang aus',
  'toast.tailorAddedToCart': 'Schneidervorgang zum Warenkorb hinzugefügt',
  'toast.deliveryBeforeToday': 'Lieferdatum kann nicht vor heute sein',
  'toast.customerOpenOrders': 'Kunde hat {count} offene Bestellungen',
  'toast.customerDebt': 'Kunde hat {amount} Schulden',
  'toast.customerSaved': 'Kunde gespeichert',
  'toast.customerSaveError': 'Fehler beim Speichern des Kunden',
  'toast.customerUpdated': 'Kunde aktualisiert',
  'toast.customerUpdateError': 'Fehler beim Aktualisieren des Kunden',
  'toast.productAddedToCart': 'Produkt zum Warenkorb hinzugefügt',
  'toast.enterValidArea': 'Bitte geben Sie eine gültige Fläche ein',
  'toast.carpetsAddedToCart': '{count} Teppiche zum Warenkorb hinzugefügt ({area} m² x {price}/m²)',
  'toast.carpetAddedToCart': 'Teppich zum Warenkorb hinzugefügt ({area} m² x {price}/m²)',
  'toast.selectAtLeastOneService': 'Bitte wählen Sie mindestens einen Service',
  'toast.productAdded': 'Produkt hinzugefügt',
  'toast.productDetailsUpdated': 'Produktdetails aktualisiert',
  'toast.priceUpdated': 'Preis aktualisiert',
  'toast.fillAllCardInfo': 'Bitte füllen Sie alle Karteninformationen aus',
  'toast.invalidCardNumber': 'Ungültige Kartennummer',
  'toast.invalidMonth': 'Ungültiger Monat (muss zwischen 1-12 sein)',
  'toast.invalidYear': 'Ungültiges Jahr',
  'toast.invalidCvc': 'Ungültiger CVC',
  'toast.cardPaymentSuccess': 'Kartenzahlung erfolgreich!',
  'toast.cardPaymentError': 'Kartenzahlung fehlgeschlagen',
  'toast.paymentFailed': 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'toast.paymentStatusCheckError': 'Fehler beim Überprüfen des Zahlungsstatus. Bitte überprüfen Sie Ihr Konto.',
  'toast.selectCustomer': 'Bitte wählen Sie einen Kunden',
  'toast.addProduct': 'Bitte fügen Sie ein Produkt hinzu',
  'toast.addressRequiredForDelivery': 'Für Hauslieferung ist eine Kundenadresse erforderlich. Bitte fügen Sie eine Adresse hinzu.',
  'toast.orderSaved': 'Bestellung gespeichert',
  'toast.orderSaveError': 'Fehler beim Speichern der Bestellung',
  'toast.enterValidValue': 'Geben Sie einen gültigen Wert ein (0-100)',
  'toast.enterValidAmount': 'Geben Sie einen gültigen Betrag ein',
  'toast.amountExceedsRemaining': 'Betrag kann nicht höher als verbleibender Saldo sein',
  'toast.selectPaymentMethodFirst': 'Wählen Sie zuerst eine Zahlungsmethode und geben Sie einen Betrag ein',
  
  'toast.receiptCopied': '📋 Quittung kopiert! Wählen Sie einen Kontakt in WhatsApp Web und fügen Sie ein (Strg+V)',
  'toast.autoCopyFailed': '⚠️ Auto-Kopieren fehlgeschlagen. Bitte kopieren Sie manuell aus der Vorschau.',
  'toast.printingLabel': 'Etikett wird gedruckt {current}/{total}...',
  'toast.markedAsReady': '✅ Bestellung als fertig markiert',
  'toast.messageCopied': '📋 Nachricht kopiert! In WhatsApp einfügen (Strg+V)',
  'toast.whatsappSending': 'WhatsApp-Nachricht wird gesendet...',
  'toast.readyMarkError': 'Fehler beim Markieren als fertig',
  'toast.markedAsDelivered': '✅ Bestellung als geliefert markiert',
  'toast.deliveredMarkError': 'Fehler beim Markieren als geliefert',
  'toast.copyFailed': '⚠️ Kopieren fehlgeschlagen. Wählen Sie den Text und drücken Sie Strg+C',
  'toast.textSelected': '✅ Text ausgewählt! Mit Strg+C kopieren',
  'toast.textSelectFailed': 'Text konnte nicht ausgewählt werden',
  'toast.statusUpdated': 'Status aktualisiert',
  'toast.smsSent': 'SMS gesendet',
  'toast.statusUpdateError': 'Fehler beim Aktualisieren des Status',
  'toast.cancelReasonRequired': 'Stornierungsgrund erforderlich',
  'toast.orderCancelled': 'Bestellung storniert',
  'toast.cancelError': 'Stornierungsfehler',
  'toast.deliverySuccess': 'Lieferung erfolgreich',
  'toast.deliveryError': 'Lieferungsfehler',
  'toast.orderSetToReady': 'Bestellung als fertig markiert',
  
  'toast.tenantIdNotFound': 'Tenant-ID nicht gefunden',
  'toast.demoProductsLoaded': 'Demo-Produkte geladen!',
  'toast.productsAddError': 'Fehler beim Hinzufügen der Produkte',
  'toast.englishNamesMigration': 'Englische Namen zu {count} Produkten hinzugefügt',
  'toast.migrationFailed': 'Migration fehlgeschlagen',
  'toast.multiLanguageConversion': '✅ {count} Produkte in mehrsprachiges Format konvertiert!',
  'toast.multiLanguageConversionError': 'Fehler bei mehrsprachiger Konvertierung',
  'toast.productNameRequired': 'Produktname ist erforderlich',
  'toast.productUpdated': 'Produkt aktualisiert',
  'toast.productDeleted': 'Produkt gelöscht',
  'toast.productDeleteError': 'Fehler beim Löschen des Produkts',
  
  'toast.whatsappNotInStarter': '⚠️ WhatsApp-Funktion ist in Ihrem Starter-Plan nicht verfügbar. Sie können auf Professional oder Enterprise upgraden.',
  'toast.schemaError': '⚠️ Datenbankschema nicht vorhanden!\\n\\nEinstellungen → "🗄️ Schema laden" → Im Supabase SQL Editor ausführen',
  
  // Order Page
  'order.deliveryDate': 'Lieferdatum',
  'order.notes': 'Notizen',
  'order.createOrder': 'Bestellung erstellen',
  'order.cancel': 'Abbrechen',
  'order.discountRate': 'Rabatt',
  'order.discountPercent': 'Rabatt ({percent}%)',
  'order.discountOptional': 'Rabatt (optional)',
  'order.enterDiscountRate': 'Rabattsatz eingeben (0-100):',
  'order.quickDiscount': 'Schnellrabatt-Tasten',
  'order.discountSummary': 'Rabattübersicht',
  'order.debt': 'Schuld',
  'order.receivable': 'Forderung',
  'order.balanced': 'Ausgeglichen',
  'order.totalDebt': 'Gesamtschuld',
  'order.totalPayments': 'Gesamtzahlungen',
  'order.homeDeliveryShort': 'Hauslieferung',
  'order.homeDeliveryIcon': '🏠 Hauslieferung',
  'order.addressIcon': '📍 Adresse',
  'order.addressRequiredForDelivery': 'Für Hauslieferung ist eine Adresse erforderlich',
  'order.priceAndDiscountEdit': 'Preis- und Rabattbearbeitung',
  'order.discount': 'Rabatt',
  'order.subtotal': 'Zwischensumme',
  'order.tax': 'MwSt',
  'order.grandTotal': 'Gesamtsumme',
  'order.payment': 'Zahlung',
  'order.paymentMethod': 'Zahlungsmethode',
  'yes': 'Ja',
  'no': 'Nein',
  'updating': 'Aktualisieren...',
  'username': 'Benutzername',
  'smsSettings': 'SMS-Einstellungen',
  'smsSettingsRequired': 'Konfigurieren Sie zuerst die SMS-Einstellungen oben und speichern Sie, bevor Sie eine Test-SMS senden',
  'testPhoneNumber': 'Test-Telefonnummer',
  'saveBeforeTest': 'Einstellungen speichern, bevor Sie eine Test-SMS senden',
  'warning': 'Warnung',
  'active': 'Aktiv',
  'inactive': 'Inaktiv',
  'optional': 'Optional',
  'required': 'Erforderlich',
  'loading': 'Laden...',
  'adding': 'Hinzufügen...',
  'saving': 'Speichern...',
  'deleting': 'Löschen...',
  'confirming': 'Bestätigen...',
  'changing': 'Ändern...',
  'changingPin': 'PIN ändern...',
  'create': 'Erstellen',
  'creating': 'Erstellen...',
  'failed': 'Fehlgeschlagen',
  'completed': 'Abgeschlossen',
  'pending': 'Ausstehend',
  'address': 'Adresse',
  'amount': 'Betrag',
  'name': 'Name',
  'email': 'E-Mail',
  'phone': 'Telefon',
  'surname': 'Nachname',
  'password': 'Passwort',
  'subtotal': 'Zwischensumme',
  'total': 'Gesamt',
  'tax': 'MwSt',
  'discount': 'Rabatt',
  'download': 'Herunterladen',
  'goHome': 'Zum Startbildschirm',
  'help': 'Hilfe',
  'info': 'Info',
  'refresh': 'Aktualisieren',
  'register': 'Registrieren',
  'import': 'Importieren',
  'details': 'Details',
  'description': 'Beschreibung',
  'cancel': 'Abbrechen',
  'confirm': 'Bestätigen',
  'clear': 'Löschen',
  'back': 'Zurück',
  'next': 'Weiter',
  'delete': 'Löschen',
  'edit': 'Bearbeiten',
  'add': 'Hinzufügen',
  'save': 'Speichern',
  'search': 'Suchen',
  'filter': 'Filtern',
  'export': 'Exportieren',
  'submit': 'Senden',
  'submitting': 'Senden...',
  'success': 'Erfolg',
  'error': 'Fehler',
  'currentPin': 'Aktueller PIN',
  'newPin': 'Neuer PIN',
  'confirmPin': 'PIN bestätigen',
  'pinChanged': 'PIN erfolgreich geändert',
  'pinError': 'PIN konnte nicht geändert werden',
  'pinDigits': '4-6 Ziffern',
  'change': 'Ändern',
  'changePin': 'PIN ändern',
  'selectLanguage': 'Sprache auswählen',
  'ifProblemPersists': 'Wenn das Problem weiterhin besteht, wenden Sie sich bitte an das Support-Team.',
  'pageNotFound': 'Seite nicht gefunden',
  'noData': 'Keine Daten gefunden',
  'zReport.title': 'Z-Bericht',
  'zReport.loadError': 'Bericht konnte nicht geladen werden',
  'zReport.loading': 'Laden...',
  'zReport.excelDownloaded': 'Excel-Datei heruntergeladen',
  'zReport.excelError': 'Excel-Datei konnte nicht erstellt werden',
  'zReport.singleDay': 'Einzelner Tag',
  'zReport.dateRange': 'Datumsbereich',
  'zReport.startDate': 'Start',
  'zReport.endDate': 'Ende',
  'zReport.totalOrders': 'Gesamtbestellungen',
  'zReport.totalRevenue': 'Gesamtumsatz',
  'zReport.collectedItems': 'Eingezogene Artikel',
  'zReport.paymentMethods': 'Zahlungsmethoden',
  'zReport.cash': 'Bargeld',
  'zReport.creditCard': 'Kreditkarte',
  'zReport.mealCard': 'Essensgutschein',
  'zReport.account': 'Konto',
  'zReport.onDelivery': 'Bei Lieferung',
  'zReport.collectionDetails': 'Einzelheiten der Sammlung',
  'zReport.orderCollections': 'Bestellungseinzüge',
  'zReport.accountCollections': 'Kontoeinzüge',
  'zReport.bankTransfer': 'Banküberweisung',
  'zReport.totalCollection': 'Gesamtsammlung',
  'zReport.expenses': 'Ausgaben',
  'zReport.noExpenses': 'Keine Ausgabendatensätze',
  'zReport.totalExpenses': 'Gesamtausgaben',
  'zReport.cancelledReceipts': 'Stornierte Belege',
  'zReport.reason': 'Grund',
  'zReport.noCancelled': 'Keine stornierten Belege',
  'zReport.totalCancelled': 'Gesamt storniert ({count} Belege)',
  'zReport.cashRegister': 'Kasse',
  'zReport.startingCash': 'Anfangskasse',
  'zReport.dailyCashIncome': 'Tägliches Bargeldeinkommen',
  'zReport.cashToDeliver': 'Bargeld zur Lieferung',
  'zReport.cancelledOrders': 'Stornierte Bestellungen',
  'zReport.paidAtRegister': 'Bei Registrierung bezahlt',
  'zReport.paidAtDelivery': 'Bei Lieferung bezahlt',
  'zReport.incoming': 'Eingehend',
  'zReport.outgoing': 'Ausgehend',
  'zReport.totalRegistered': 'Gesamt registriert',
  'zReport.todayOrders': "Heutige Bestellungen",
  'zReport.registrationAndDelivery': 'Registrierung + Lieferung',
  'zReport.orderPaidAtRegister': 'Bei Registrierung bezahlte Bestellung',
  'zReport.orderPaidAtDelivery': 'Bei Lieferung bezahlte Bestellung',
  'zReport.cashCalculation': '(Anfang + Heutige Bar - Ausgaben)',
   
  // Missing common keys
  'actions': 'Aktionen',
  'canceling': 'Wird abgebrochen...',
  'close': 'Schließen',
  'common.clear': 'Löschen',
  'common.copied': 'Kopiert!',
  'common.copyError': 'Kopieren fehlgeschlagen',
  'common.export': 'Exportieren',
  'common.exportExcel': 'Excel herunterladen',
  'common.exportToExcel': 'Nach Excel exportieren',
  'common.filter': 'Filtern',
  'common.next': 'Weiter',
  'common.previous': 'Zurück',
  'common.print': 'Drucken',
  'common.printDate': 'Druckdatum',
  'common.reset': 'Zurücksetzen',
  
  // Error boundary
  'errorBoundary.forbidden': 'Zugriff Verboten',
  'errorBoundary.forbiddenDetails': 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
  'errorBoundary.pageNotFound': 'Seite Nicht Gefunden',
  'errorBoundary.pageNotFoundDetails': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
  'errorBoundary.technicalDetails': 'Technische Details',
  'errorBoundary.reload': 'Seite Neu Laden',
  'errorBoundary.goHome': 'Zur Startseite',
  'errorBoundary.serverError': 'Serverfehler',
  'errorBoundary.serverErrorDetails': 'Ein serverseitiger Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
  'errorBoundary.persistentIssue': 'Wenn das Problem weiterhin besteht, wenden Sie sich an das Support-Team.',
  
  // Customers
  'customers.totalOrders': 'Gesamtbestellungen',
  'customers.totalSpent': 'Gesamtausgaben',
  
  // Dashboard
  'dashboard.totalOrdersCard': 'Gesamtbestellungen',
  
  // Date
  'date': 'Datum',
  
  // Form
  
  // Confirm delete
  'confirmDelete': 'Löschen Bestätigen',
  'confirmDeleteMessage': 'Sind Sie sicher, dass Sie "{name}" löschen möchten?',
  'confirmDeleteDesc': 'Diese Aktion kann nicht rückgängig gemacht werden.',
  
  // Payment
  'order.selectPaymentMethod': 'Zahlungsmethode auswählen',
  
  // Users
  'users.delete': 'Löschen',
  'users.deleteUserTitle': 'Benutzer löschen',
  'users.deletingUser': 'Sind Sie sicher, dass Sie den Benutzer {name} löschen möchten?',
  'users.deleteError': 'Benutzer konnte nicht gelöscht werden',
  'users.loadError': 'Benutzer konnten nicht geladen werden',
  'users.userDeleted': 'Benutzer erfolgreich gelöscht',
  'users.userDeleteError': 'Benutzer konnte nicht gelöscht werden',
  
  // Products
  'products.newProduct': 'Neues Produkt',
  'products.editProduct': 'Produkt bearbeiten',
  'products.productName': 'Produktname',
  'products.productPrice': 'Preis',
  'products.productCategory': 'Kategorie',
  'products.productActive': 'Aktiv',
  'products.productInActive': 'Inaktiv',
  'products.pieceCount': 'Stückzahl',
  'products.updatePrice': 'Preis aktualisieren',
  'products.updatePrices': 'Preise aktualisieren',
  'products.allCategories': 'Alle Kategorien',
  'products.searchProduct': 'Produkt suchen...',
  'products.save': 'Speichern',
  'products.saving': 'Wird gespeichert...',
  'products.saved': 'Gespeichert',
  'products.saveError': 'Speichern fehlgeschlagen',
  'products.deleteConfirm': 'Sind Sie sicher, dass Sie dieses Produkt löschen möchten?',
  'products.delete': 'Löschen',
  'products.deleting': 'Wird gelöscht...',
  'products.loadError': 'Produkte konnten nicht geladen werden',
  'products.addError': 'Produkt konnte nicht hinzugefügt werden',
  'products.updateError': 'Produkt konnte nicht aktualisiert werden',
  'products.deleteError': 'Produkt konnte nicht gelöscht werden',
  'products.productAdded': 'Produkt hinzugefügt',
  'products.productUpdated': 'Produkt aktualisiert',
  'products.productDeleted': 'Produkt gelöscht',
  
  // Attributes
  'attributes.addColor': 'Farbe hinzufügen',
  'attributes.addStain': 'Fleckentyp hinzufügen',
  'attributes.addDamage': 'Schadenstyp hinzufügen',
  'attributes.save': 'Speichern',
  'attributes.saved': 'Gespeichert',
  'attributes.saveError': 'Speichern fehlgeschlagen',
  'attributes.loadError': 'Attribute konnten nicht geladen werden',
  'attributes.addError': 'Hinzufügen fehlgeschlagen',
  'attributes.updateError': 'Aktualisieren fehlgeschlagen',
  'attributes.deleteError': 'Löschen fehlgeschlagen',
  
  // Delivery
  'delivery.title': 'Lieferverwaltung',
  'delivery.pending': 'In Bearbeitung',
  'delivery.ready': 'Fertig',
  'delivery.delivered': 'Geliefert',
  'delivery.orderNumber': 'Bestellung Nr.',
  'delivery.customer': 'Kunde',
  'delivery.items': 'Artikel',
  'delivery.total': 'Gesamt',
  'delivery.deliveryDate': 'Lieferdatum',
  'delivery.status': 'Status',
  'delivery.actions': 'Aktionen',
  'delivery.markReady': 'Als fertig markieren',
  'delivery.markDelivered': 'Als geliefert markieren',
  'delivery.printReceipt': 'Quittung drucken',
  'delivery.searchOrder': 'Nach Bestellnummer oder Kundennamen suchen...',
  'delivery.loadError': 'Lieferungen konnten nicht geladen werden',
  'delivery.updateError': 'Status konnte nicht aktualisiert werden',
  'delivery.orderReady': 'Bestellung als fertig markiert',
  'delivery.orderDelivered': 'Bestellung als geliefert markiert',
  'delivery.noOrders': 'Keine Bestellungen gefunden',
  
  // Notifications
  'notifications.title': 'Benachrichtigungen',
  'notifications.send': 'Senden',
  'notifications.sending': 'Wird gesendet...',
  'notifications.sent': 'Gesendet',
  'notifications.sendError': 'Senden fehlgeschlagen',
  'notifications.selectCustomer': 'Kunde auswählen',
  'notifications.selectTemplate': 'Vorlage auswählen',
  'notifications.customMessage': 'Benutzerdefinierte Nachricht',
  'notifications.message': 'Nachricht',
  'notifications.preview': 'Vorschau',
  'notifications.whatsapp': 'WhatsApp',
  'notifications.sms': 'SMS',
  'notifications.sendNow': 'Jetzt senden',
  'notifications.schedule': 'Planen',
  'notifications.scheduleLater': 'Später senden',
  'notifications.selectDateTime': 'Datum und Uhrzeit auswählen',
  'notifications.success': 'Benachrichtigung erfolgreich gesendet',
  'notifications.failure': 'Senden der Benachrichtigung fehlgeschlagen',
  
  // Profile
  'profile.title': 'Profil',
  'profile.name': 'Name',
  'profile.email': 'E-Mail',
  'profile.phone': 'Telefon',
  'profile.role': 'Rolle',
  'profile.save': 'Speichern',
  'profile.saving': 'Wird gespeichert...',
  'profile.saved': 'Gespeichert',
  'profile.saveError': 'Profil konnte nicht gespeichert werden',
  'profile.changePassword': 'Passwort ändern',
  'profile.currentPassword': 'Aktuelles Passwort',
  'profile.newPassword': 'Neues Passwort',
  'profile.confirmPassword': 'Passwort bestätigen',
  'profile.passwordMismatch': 'Passwörter stimmen nicht überein',
  'profile.passwordChanged': 'Passwort erfolgreich geändert',
  'profile.passwordChangeError': 'Passwort konnte nicht geändert werden',
  
  // Settings
  'settings.companyInfo': 'Firmeninfo',
  'settings.companyNamePlaceholder': 'Firmenname eingeben',
  'settings.languageRegion': 'Sprache und Region',
  'settings.addressPlaceholder': 'Firmenadresse eingeben',
  'settings.logo': 'Logo',
  'settings.demoProducts': 'Demo-Produkte',
  'settings.demoProductsDescription': 'Fügt Demo-Produkte mit definierten Preisen hinzu',
  'settings.addDemoProducts': 'Demo-Produkte hinzufügen',
  'settings.adding': 'Wird hinzugefügt...',
  'settings.delete': 'Löschen',
  'settings.showTax': 'Steuer anzeigen',
  'settings.footerText': 'Fußtext',
  'settings.footerTextPlaceholder': 'Text, der unten auf der Quittung erscheint...',
  'settings.headerInfo': 'Kopftext',
  'settings.headerInfoPlaceholder': 'z.B: Chemische Reinigung und Bügeln',
  'settings.phonePlaceholder': 'z.B: 0212 123 45 67',
  'settings.footerTextHelp': 'Kurze Nachricht unten auf der Quittung',
  'settings.receiptNoteHelp': 'Detaillierte Geschäftsbedingungen',
  'settings.receiptPreview': 'Quittungsvorschau',
  'settings.numberFormatDotComma': 'Punkt für Dezimal (1.234,56)',
  'settings.numberFormatCommaDot': 'Komma für Dezimal (1,234.56)',
  'settings.numberFormatSpaceComma': 'Leerzeichen für Dezimal (1 234,56)',
  'settings.receiptNotePlaceholder': 'Quittungsnotiz eingeben',
  'settings.loadSchema': 'Schema laden',
  'settings.loadSchemaTitle': 'Datenbankschema laden',
  'settings.loadSchemaConfirm': 'Dies erstellt das Datenbankschema. Fortfahren?',
  'settings.connected': 'Verbunden',
  'settings.notConnected': 'Nicht verbunden',
  'settings.connect': 'Verbinden',
  'settings.disconnect': 'Trennen',
  
  // Toasts
  'toast.demoDataDeleted': 'Demo-Daten gelöscht',
  'toast.demoDataDeleteError': 'Demo-Daten konnten nicht gelöscht werden',
  'toast.orderCreated': 'Bestellung erstellt',
  'toast.orderError': 'Bestellung konnte nicht erstellt werden',
  'toast.customerAdded': 'Kunde hinzugefügt',
  'toast.customerError': 'Kunde konnte nicht hinzugefügt werden',
  'toast.productError': 'Produkt konnte nicht hinzugefügt werden',
  'toast.qrGenerated': 'QR-Code generiert. Bitte mit Ihrer WhatsApp Business App scannen.',
  'toast.qrError': 'QR-Code konnte nicht generiert werden',
  'toast.whatsappConnected': 'WhatsApp Business erfolgreich verbunden!',
  'toast.whatsappDisconnected': 'WhatsApp Business getrennt',
  'toast.connectionError': 'Verbindung konnte nicht gespeichert werden',
  'toast.disconnectError': 'Trennung fehlgeschlagen',
  'toast.connectionStatusError': 'Verbindungsstatus konnte nicht geladen werden',
  'toast.statsError': 'Statistiken konnten nicht geladen werden',
  'toast.userAdded': 'Benutzer hinzugefügt',
  'toast.userAddError': 'Benutzer konnte nicht hinzugefügt werden',
  'toast.userUpdated': 'Benutzer aktualisiert',
  'toast.userUpdateError': 'Benutzer konnte nicht aktualisiert werden',
  'toast.usersLoadError': 'Benutzer konnten nicht geladen werden',
  'toast.pinChanged': 'PIN-Code geändert',
  'toast.pinChangeError': 'PIN-Code konnte nicht geändert werden',
  'toast.userDeleted': 'Benutzer erfolgreich gelöscht',
  'toast.userDeleteError': 'Benutzer konnte nicht gelöscht werden',
  
  // Login
  'login.demoLoaded': 'Demo-Benutzer, Produkte, Kunden und Bestellungen erstellt!',
  'login.usernameRequired': 'Benutzername ist erforderlich',
  'login.pinRequired': 'PIN ist erforderlich',
  'login.invalidCredentials': 'Ungültiger Benutzername oder PIN',
  'login.rememberMe': 'Angemeldet bleiben',
  'login.tenantRequired': 'Firmen-ID ist erforderlich',
  'login.tenantIdNotRemembered': 'Firmen-ID nicht gespeichert',
  'login.username': 'Benutzername',
  'login.pin': 'PIN',
  'login.signIn': 'Anmelden',
  'login.signingIn': 'Anmeldung...',
  'login.tryForFree': '30 Tage kostenlos testen, keine Kreditkarte erforderlich',
  'login.pinDescription': '4-6 Ziffern',
  'login.firstLoginChangePin': 'Erste Anmeldung - Bitte ändern Sie Ihren PIN-Code',
  'login.legalText': 'Mit der Erstellung eines Kontos stimmen Sie unseren Nutzungsbedingungen und Datenschutzrichtlinien zu',
  'login.demoAccount': 'Demo-Konto',
  'login.demoCredentials': 'Benutzername: demo, PIN: 1234',
  'login.version': 'Version',
  
  // Common
  'common.perPage': 'Pro Seite',
  'common.page': 'Seite',
  'common.orders': 'Bestellungen',
  'common.pieces': 'Stück',

  // Additional missing translations
  'color.beige': 'Beige',
  'color.black': 'Schwarz',
  'color.blue': 'Blau',
  'color.brown': 'Braun',
  'color.burgundy': 'Burgunder',
  'color.gray': 'Grau',
  'color.green': 'Grün',
  'color.navy': 'Marineblau',
  'color.orange': 'Orange',
  'color.other': 'Andere',
  'color.pink': 'Rosa',
  'color.purple': 'Lila',
  'color.red': 'Rot',
  'color.teal': 'Blaugrün',
  'color.white': 'Weiß',
  'color.yellow': 'Gelb',
  'customers.confirmDeleteSelected': 'Sind Sie sicher, dass Sie {count} Kunden löschen möchten?',
  'customers.deleteSelected': 'Ausgewählte Löschen',
  'customers.deselectAll': 'Alle Abwählen',
  'customers.import': 'Kunden Importieren',
  'customers.importDesc': 'Kunden aus Excel-Datei importieren',
  'customers.importError': 'Fehler beim Importieren der Kunden',
  'customers.importSuccess': '{count} Kunden erfolgreich importiert',
  'customers.importTitle': 'Kunden Importieren',
  'customers.lastOrder': 'Letzte Bestellung',
  'customers.openOrders': 'Offene Bestellungen',
  'customers.registerDate': 'Registrierungsdatum',
  'customers.searchHint': 'Geben Sie mindestens 2 Zeichen ein, um zu suchen',
  'customers.selectAll': 'Alle Auswählen',
  'customers.selected': '{count} ausgewählt',
  'damage.buttonMissing': 'Knopf Fehlt',
  'damage.delik': 'Kleine Löcher',
  'damage.fade': 'Verblasst',
  'damage.hole': 'Loch',
  'damage.lining': 'Futter',
  'damage.none': 'Kein Schaden',
  'damage.other': 'Andere',
  'damage.pembe': 'Rosa',
  'damage.seam': 'Naht',
  'damage.tear': 'Riss',
  'damage.worn': 'Abgetragen',
  'damage.zipper': 'Reißverschluss',
  'error.customerNotCreated': 'Kunde konnte nicht erstellt werden',
  'error.customerNotDeleted': 'Kunde konnte nicht gelöscht werden',
  'error.customerNotFound': 'Kunde nicht gefunden',
  'error.customerNotUpdated': 'Kunde konnte nicht aktualisiert werden',
  'error.customersNotLoaded': 'Kunden konnten nicht geladen werden',
  'error.databaseError': 'Datenbankfehler',
  'error.expenseNotCreated': 'Ausgabe konnte nicht erstellt werden',
  'error.expenseNotDeleted': 'Ausgabe konnte nicht gelöscht werden',
  'error.expensesNotLoaded': 'Ausgaben konnten nicht geladen werden',
  'error.forbidden': 'Sie haben keine Berechtigung für diese Aktion',
  'error.invalidRequest': 'Ungültige Anfrage',
  'error.ordersNotLoaded': 'Bestellungen konnten nicht geladen werden',
  'error.paymentFailed': 'Zahlung fehlgeschlagen',
  'error.productNotCreated': 'Produkt konnte nicht erstellt werden',
  'error.productNotUpdated': 'Produkt konnte nicht aktualisiert werden',
  'error.productsNotLoaded': 'Produkte konnten nicht geladen werden',
  'error.serverError': 'Serverfehler',
  'error.tenantIdRequired': 'Sitzungsinformationen erforderlich',
  'error.tenantIdRequiredLogin': 'Sitzungsinformationen erforderlich. Bitte melden Sie sich an.',
  'error.unauthorized': 'Nicht autorisierter Zugriff',
  'error.unknownError': 'Ein unbekannter Fehler ist aufgetreten',
  'error.userNotCreated': 'Benutzer konnte nicht erstellt werden',
  'error.userNotUpdated': 'Benutzer konnte nicht aktualisiert werden',
  'error.usersNotLoaded': 'Benutzer konnten nicht geladen werden',
  'errorBoundary.unauthorized': 'Nicht Autorisiert',
  'errorBoundary.unauthorizedDetails': 'Sie sind nicht berechtigt, diese Aktion durchzuführen.',
  'errorBoundary.unknownError': 'Unbekannter Fehler',
  'expenses.add': 'Ausgabe Hinzufügen',
  'expenses.date': 'Datum',
  'expenses.delete': 'Löschen',
  'expenses.save': 'Speichern',
  'expenses.saving': 'Wird gespeichert...',
  'login': 'Anmelden',
  'logout': 'Abmelden',
  'notifications': 'Benachrichtigungen',
  'order.addProduct': 'Produkt Hinzufügen',
  'order.customer': 'Kunde',
  'order.newCustomer': 'Neuer Kunde',
  'order.price': 'Preis',
  'order.products': 'Produkte',
  'order.quantity': 'Menge',
  'order.selectCustomer': 'Kunde Auswählen',
  'order.selectProduct': 'Produkt Auswählen',
  'order.title': 'Neue Bestellung',
  'order.total': 'Gesamt',
  'pricing.saveError': 'Speichern fehlgeschlagen',
  'pricing.saved': 'Gespeichert',
  'reports.custom': 'Benutzerdefiniert',
  'reports.customers': 'Kunden',
  'reports.dateRange': 'Datumsbereich',
  'reports.export': 'Exportieren',
  'reports.orders': 'Bestellungen',
  'reports.print': 'Drucken',
  'reports.products': 'Produkte',
  'reports.sales': 'Verkäufe',
  'reports.thisMonth': 'Dieser Monat',
  'reports.thisWeek': 'Diese Woche',
  'reports.thisYear': 'Dieses Jahr',
  'reports.title': 'Berichte',
  'reports.today': 'Heute',
  'settings.expenses': 'Ausgaben',
  'settings.invoices': 'Rechnungen',
  'settings.menu': 'Einstellungsmenü',
  'settings.reports': 'Berichte',
  'settings.tickets': 'Support-Tickets',
  'settings.zReport': 'Z-Bericht',
  'stain.grease': 'Fett',
  'stain.sweat': 'Schweiß',
  'stain.unknown': 'Unbekannt',
  'toast.orderStatusUpdateError': 'Fehler beim Aktualisieren des Bestellstatus',
  'toast.orderStatusUpdated': 'Bestellstatus aktualisiert',
  'whatsapp.messageHistory': 'Nachrichtenverlauf',
  'whatsapp.messages': 'Nachrichten',
  'zReport.cardSales': 'Kartenzahlungen',
  'zReport.cashSales': 'Barverkäufe',
  'zReport.creditSales': 'Kreditverkäufe',
  'zReport.date': 'Datum',
  'zReport.noData': 'Keine Daten für diesen Zeitraum',
  'zReport.period': 'Zeitraum',
  'zReport.print': 'Bericht Drucken',
  'zReport.totalSales': 'Gesamtumsatz',
  
  // Toast Messages
  'toast.productAddedSimple': 'Produkt hinzugefügt',
  'toast.deliveryDatePastError': 'Lieferdatum kann nicht vor heute liegen',
  'toast.cardPaymentSuccessMsg': 'Kartenzahlung erfolgreich!',
  'toast.cardPaymentFailed': 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'toast.paymentStatusCheckErrorShort': 'Zahlungsstatus konnte nicht überprüft werden.',
  'toast.changeToPickupSuccess': 'Lieferart wurde auf "Persönliche Abholung" geändert',
  'toast.changeToPickupError': 'Lieferart konnte nicht geändert werden',
  'toast.changeToDeliverySuccess': 'Lieferart wurde auf "Hauslieferung" geändert',
  'toast.changeToDelivery': 'Hauslieferung',
  'toast.changeToPickup': 'Persönliche Abholung',
  'deliveryPage.changeDeliveryType': 'Lieferart ändern',
  'zReport.todayRegistrations': 'Registrierungen von heute',

  // Fehlende Common-Schlüssel
  'common.allYears': 'Alle Jahre',
  'common.autoDetected': 'Automatisch erkannt',
  'common.cancelled': 'Storniert',
  'common.items': 'Artikel',
  'common.loadError': 'Konnte nicht geladen werden',
  'common.none': 'Keine',
  'common.ok': 'OK',
  'common.paid': 'Bezahlt',
  'common.searchError': 'Suchfehler',
  'common.searchResults': '(Suchergebnisse)',
  'common.unit': 'Einheit',
  'common.year': 'Jahr',

  // Kontoauszug
  'accountStatement.allTime': 'Gesamter Zeitraum',
  'accountStatement.customer': 'Kunde',
  'accountStatement.customerReceipts': 'Kundenquittungen',
  'accountStatement.noData': 'Keine Kontoauszüge gefunden',
  'accountStatement.noReceipts': 'Keine Quittungen gefunden',
  'accountStatement.payments': 'Zahlungen',
  'accountStatement.period': 'Zeitraum',
  'accountStatement.printStatement': 'Kontoauszug drucken',
  'accountStatement.receipts': 'Quittungen',
  'accountStatement.remaining': 'Restbetrag',
  'accountStatement.statement': 'Kontoauszug',
  'accountStatement.totalPaid': 'Gesamt bezahlt',

  // Ankündigung
  'announcement.trialInfo': 'Testperiode läuft',
  'announcement.welcome': 'Willkommen',

  // Attribute
  'attributes.color': 'Farbe',
  'attributes.deleteError': 'Attribut konnte nicht gelöscht werden',
  'attributes.deleted': 'Attribut gelöscht',
  'attributes.name': 'Attributname',
  'attributes.noAttributes': 'Keine Attribute definiert',
  'attributes.saveError': 'Attribute konnten nicht gespeichert werden',
  'attributes.saved': 'Attribute gespeichert',
  'attributes.value': 'Wert',

  // Kundenauszug
  'customerStatement.receiptDelivered': 'Geliefert',
  'customerStatement.receiptOpen': 'Offen',

  // Kunden
  'customers.add': 'Kunde hinzufügen',
  'customers.adres': 'Adresse',
  'customers.cannotDeleteWithOrders': 'Kunden mit Bestellungen können nicht gelöscht werden',
  'customers.legacyHidden': 'Versteckt (Alt)',
  'customers.notFound': 'Kunde nicht gefunden',
  'customers.phoneMissing': 'Telefonnummer fehlt',
  'customers.telefon': 'Telefon',
  'customers.telefon2': 'Telefon 2',

  // Schaden
  'damage.add': 'Schaden hinzufügen',
  'damage.description': 'Beschreibung',
  'damage.location': 'Ort',
  'damage.noPhoto': 'Kein Foto',
  'damage.photo': 'Foto',
  'damage.saveError': 'Schadensbericht konnte nicht gespeichert werden',
  'damage.saved': 'Schadensbericht gespeichert',
  'damage.severity': 'Schweregrad',
  'damage.title': 'Schadensprotokoll',
  'damage.type': 'Schadensart',

  // Dashboard
  'dashboard.allTime': 'Gesamter Zeitraum',
  'dashboard.referral.button': 'Einladungslink kopieren',
  'dashboard.referral.desc': '1 Monat extra, wenn sich ein eingeladenes Unternehmen registriert!',
  'dashboard.referral.title': 'Freunde einladen',

  // Lieferung
  'delivery.complete': 'Ausliefern',
  'delivery.deliveredItems': 'Gelieferte Artikel',
  'delivery.deliveredProducts': 'Gelieferte Produkte',
  'delivery.error': 'Lieferfehler',
  'delivery.noOrders': 'Keine Bestellungen gefunden',
  'delivery.success': 'Lieferung erfolgreich',

  // Lieferliste
  'deliveryList.address': 'Adresse',
  'deliveryList.cancelButton': 'Stornieren',
  'deliveryList.cancelConfirm': 'Stornierung bestätigen',
  'deliveryList.cancelReasonPlaceholder': 'Stornogrund eingeben...',
  'deliveryList.cancelTitle': 'Bestellung stornieren',
  'deliveryList.complete': 'Abschließen',
  'deliveryList.completed': 'Abgeschlossen',
  'deliveryList.delivered': 'Geliefert',
  'deliveryList.deliveryError': 'Lieferfehler',
  'deliveryList.driver': 'Fahrer',
  'deliveryList.items': 'Artikel',
  'deliveryList.messageError': 'Nachrichtenfehler',
  'deliveryList.orderCancelled': 'Bestellung storniert',
  'deliveryList.orderDelivered': 'Bestellung geliefert',
  'deliveryList.pending': 'Ausstehend',
  'deliveryList.phone': 'Telefon',
  'deliveryList.selectDriver': 'Fahrer auswählen',
  'deliveryList.status': 'Status',
  'deliveryList.title': 'Lieferliste',
  'deliveryList.whatsappError': 'WhatsApp-Fehler',
  'deliveryList.whatsappSent': 'WhatsApp gesendet',

  // Lieferseite
  'deliveryPage.changeToDelivery': 'Zur Lieferung wechseln',
  'deliveryPage.changeToDeliverySuccess': 'Zu Lieferung geändert',
  'deliveryPage.changeToPickup': 'Zur Abholung wechseln',
  'deliveryPage.changeToPickupError': 'Änderung fehlgeschlagen',
  'deliveryPage.changeToPickupSuccess': 'Zu Abholung geändert',
  'deliveryPage.searchAll': 'Alle',
  'deliveryPage.searchBy': 'Suchen nach',
  'deliveryPage.searchName': 'Kundenname',
  'deliveryPage.searchNamePlaceholder': 'Name eingeben...',
  'deliveryPage.searchPhone': 'Telefon',
  'deliveryPage.searchPhoneBtn': 'Telefon suchen',
  'deliveryPage.searchPlaceholder': 'Suchen...',
  'deliveryPage.searchReceipt': 'Belegnr.',
  'deliveryPage.searchReceiptPlaceholder': 'Belegnr. eingeben...',

  // Fahrer
  'driver.searchHint': 'Mindestens 2 Zeichen eingeben',
  'driver.searchPlaceholder': 'Belegnr., Name oder Telefon...',

  // Fußzeile
  'footer.euServers': 'EU-Server',
  'footer.gdpr': 'DSGVO-konform',

  // Rechnungen
  'invoices.downloading': 'Wird heruntergeladen...',

  // Anmeldung
  'login.credentialsTitle': 'Anmeldedaten',
  'login.enterCredentials': 'Anmeldedaten eingeben',
  'login.forget': 'Passwort vergessen?',
  'login.saveCredentialsNote': 'Anmeldedaten sicher gespeichert',
  'login.tagline': 'Reinigungssoftware — Intelligente Lösungen für Ihr Unternehmen.',
  'login.usernamePlaceholder': 'Benutzername eingeben...',

  // Menü
  'menu.driverPickup': 'Fahrerabholung',
  'menu.hardware': 'Hardware',
  'menu.payment': 'Zahlung',
  'menu.reportsCharts': 'Berichte & Diagramme',

  // Navigation
  'nav.logout': 'Abmelden',
  'nav.user': 'Benutzer',

  // Bestellung
  'order.amount': 'Betrag',
  'order.homeDelivery': 'Hauslieferung',
  'order.processing': 'Wird verarbeitet...',

  // Bestellung erstellen
  'orderCreate.pickupFromAddress': 'Von Adresse abholen',
  'orderCreate.selectOperation': 'Vorgang auswählen',
  'orderCreate.selectedOperations': 'Ausgewählte Vorgänge',

  // Zahlung
  'payment.bank': 'Banküberweisung',
  'payment.adjustment': 'Saldokorrektur',
  'payment.collect': 'Einzug',
  'payment.credit': 'Kredit',
  'payment.free': 'Kostenlos',
  'payment.paymentCare': 'Kontenzahlung',
  'payment.paymentsSaved': 'Zahlungen gespeichert',
  'payment.saveError': 'Zahlungen konnten nicht gespeichert werden',
  'payment.saved': 'Zahlung gespeichert',
  'payment.split': 'Aufgeteilte Zahlung',

  // Platzhalter
  'placeholder.customerAddress': 'Adresse eingeben...',
  'placeholder.customerEmail': 'E-Mail eingeben...',
  'placeholder.customerName': 'Name eingeben...',
  'placeholder.customerNotes': 'Notizen eingeben...',
  'placeholder.customerPhone': 'Telefon eingeben...',

  // Preisgestaltung
  'pricing.amount': 'Betrag',
  'pricing.enterPrice': 'Preis eingeben',
  'pricing.percent': 'Prozent',

  // Produkt
  'product.damage': 'Schaden',
  'product.stain': 'Fleck',

  // Quittung
  'receipt.addressLabel': 'Adresse',
  'receipt.allYears': 'Alle Jahre',
  'receipt.area': 'Fläche',
  'receipt.backButton': 'Zurück',
  'receipt.buyCredits': 'Credits kaufen',
  'receipt.cancelled': 'Storniert',
  'receipt.cancelledBanner': 'Diese Bestellung wurde storniert',
  'receipt.cancelledBy': 'Storniert von',
  'receipt.cancelledDate': 'Stornierungsdatum',
  'receipt.cancelledReason': 'Stornogrund',
  'receipt.card': 'Karte',
  'receipt.cash': 'Bar',
  'receipt.change': 'Wechselgeld',
  'receipt.connect': 'Verbinden',
  'receipt.connected': 'Verbunden',
  'receipt.copyButton': 'Kopieren',
  'receipt.copySend': 'Kopieren & Senden',
  'receipt.copyTip': 'Nachricht kopieren',
  'receipt.creditsFinished': 'WhatsApp-Credits aufgebraucht!',
  'receipt.customer': 'Kunde',
  'receipt.customerInfo': 'Kundeninfo',
  'receipt.customerName': 'Kundenname',
  'receipt.deliveryDate': 'Lieferdatum',
  'receipt.discount': 'Rabatt',
  'receipt.discountedTotal': 'Rabattierter Betrag',
  'receipt.footerNote': 'Fußnotentext',
  'receipt.freeOfCharge': 'Kostenlos',
  'receipt.generalTotal': 'Gesamtsumme',
  'receipt.goToWhatsAppPage': 'Zur WhatsApp-Seite gehen?',
  'receipt.grandTotal': 'Endsumme',
  'receipt.homeDelivery': 'Hauslieferung',
  'receipt.invalid': 'Ungültige Quittung',
  'receipt.items': 'Artikel',
  'receipt.label': 'Etikett',
  'receipt.labelPrinted': 'Etikett gedruckt',
  'receipt.markAsDelivered': 'Als geliefert markieren',
  'receipt.markAsReady': 'Als bereit markieren',
  'receipt.markDeliveredError': 'Fehler beim Markieren als geliefert',
  'receipt.markReadyError': 'Fehler beim Markieren als bereit',
  'receipt.messageFailed': 'Nachricht konnte nicht gesendet werden',
  'receipt.messageSendFailed': 'Nachricht konnte nicht gesendet werden',
  'receipt.messageSent': 'Nachricht gesendet!',
  'receipt.new': 'Neuer Beleg',
  'receipt.noCollection': 'Keine Kollektion',
  'receipt.noReceiptFound': 'Kein Beleg gefunden',
  'receipt.notes': 'Notizen',
  'receipt.onlyProEnterprise': 'Nur Pro/Enterprise',
  'receipt.openWhatsApp': 'WhatsApp öffnen',
  'receipt.orderMarkedDelivered': 'Bestellung als geliefert markiert',
  'receipt.orderMarkedReady': 'Bestellung als bereit markiert',
  'receipt.orderNumber': 'Bestellnummer',
  'receipt.orderReceived': 'Bestellung erhalten',
  'receipt.paid': 'Bezahlt',
  'receipt.partialPayment': 'Teilzahlung',
  'receipt.paymentMethod': 'Zahlungsmethode',
  'receipt.phone': 'Telefon',
  'receipt.phoneNotFound': 'Telefonnummer nicht gefunden',
  'receipt.piece': 'Stück',
  'receipt.preview': 'Vorschau',
  'receipt.printError': 'Druckfehler',
  'receipt.printerConnectError': 'Drucker konnte nicht verbunden werden',
  'receipt.productsInfo': 'Produkte',
  'receipt.receiptInfo': 'Beleginformationen',
  'receipt.remaining': 'Restbetrag',
  'receipt.remainingCredits': 'Verbleibende Credits',
  'receipt.reprint': 'Neu drucken',
  'receipt.scanQR': 'QR-Code scannen',
  'receipt.searchAll': 'Alle',
  'receipt.searchBy': 'Suchen nach',
  'receipt.searchError': 'Suchfehler',
  'receipt.searchName': 'Kundenname',
  'receipt.searchPhone': 'Telefon',
  'receipt.searchReceipt': 'Belegnr.',
  'receipt.searchReceiptPlaceholder': 'Belegnr. eingeben...',
  'receipt.searchTitle': 'Beleg suchen',
  'receipt.selectAll': 'Alle auswählen',
  'receipt.serviceSummary': 'Dienstleistungsübersicht',
  'receipt.sessionNotFound': 'Sitzung nicht gefunden. Bitte erneut anmelden.',
  'receipt.status': 'Status',
  'receipt.thermalPrinter': 'Thermodrucker',
  'receipt.thisReceiptCancelled': 'Dieser Beleg wurde storniert',
  'receipt.unknownError': 'Unbekannter Fehler',
  'receipt.whatsappFeature': 'WhatsApp-Funktion',
  'receipt.whatsappNotConnected': 'WhatsApp nicht verbunden!',
  'receipt.whatsappPreview': 'WhatsApp-Vorschau',
  'receipt.whatsappPreviewDesc': 'Nachrichtenvorschau',
  'receipt.whatsappPreviewTitle': 'Vorschau',
  'receipt.year': 'Jahr',

  // Berichte
  'reports.averageOrder': 'Durchschnittliche Bestellung',
  'reports.ordersCount': 'Anzahl der Bestellungen',
  'reports.salesReport': 'Verkaufsbericht',
  'reports.totalSales': 'Gesamtumsatz',

  // Dienste
  'service.carpetShort': 'Teppich',
  'service.dryCleaningShort': 'Reinigung',
  'service.ironingShort': 'Bügeln',
  'service.dyeingShort': 'Färben',
  'service.shoeShineShort': 'Schuhe',
  'service.tailoringShort': 'Schneider',
  'service.washingShort': 'Waschen',

  // Einstellungen
  'settings.africa': 'Afrika',
  'settings.americas': 'Amerika',
  'settings.asia': 'Asien',
  'settings.asiaPacific': 'Asien-Pazifik',
  'settings.asianLanguages': 'Asiatische Sprachen',
  'settings.autoConnect': 'Automatisch verbinden',
  'settings.browserNotSupported': 'Browser nicht unterstützt',
  'settings.callerId': 'Anrufer-ID',
  'settings.clickConnectButton': 'Klicken Sie auf Verbinden',
  'settings.company': 'Unternehmen',
  'settings.connectDeviceInfo': 'Geräteinformationen',
  'settings.cut': 'Abschneiden',
  'settings.email': 'E-Mail',
  'settings.europe': 'Europa',
  'settings.europeanLanguages': 'Europäische Sprachen',
  'settings.feedForward': 'Papiervorschub',
  'settings.formerSovietTurkic': 'Ehemalige sowjetische Türksprachen',
  'settings.genericEscPos': 'Generisches ESC/POS',
  'settings.howToConnect': 'Wie verbinden',
  'settings.integrations': 'Integrationen',
  'settings.labelPrinter': 'Etikettendrucker',
  'settings.lastCall': 'Letzter Anruf',
  'settings.majorCurrencies': 'Hauptwährungen',
  'settings.middleEast': 'Naher Osten',
  'settings.middleEastAfricanLanguages': 'Naher Osten & Afrika Sprachen',
  'settings.middleEastGulf': 'Naher Osten Golf',
  'settings.notifications': 'Benachrichtigungen',
  'settings.oceania': 'Ozeanien',
  'settings.openDrawer': 'Lade öffnen',
  'settings.otherLanguages': 'Andere Sprachen',
  'settings.paperWidth': 'Papierbreite',
  'settings.popularLanguages': 'Beliebte Sprachen',
  'settings.printer': 'Drucker',
  'settings.printerConnect': 'Drucker verbinden',
  'settings.printerConnected': 'Drucker verbunden',
  'settings.printerConnection': 'Druckerverbindung',
  'settings.printerDisconnect': 'Drucker trennen',
  'settings.printerModel': 'Druckermodell',
  'settings.printerNotConnected': 'Drucker nicht verbunden',
  'settings.printerSettings': 'Druckereinstellungen',
  'settings.receiptVisibleOnReceipt': 'Auf Quittung sichtbar',
  'settings.reverse': 'Umkehren',
  'settings.reverseTest': 'Umkehrtest',
  'settings.saveError': 'Einstellungen konnten nicht gespeichert werden',
  'settings.saved': 'Einstellungen gespeichert',
  'settings.selectDevice': 'Gerät auswählen',
  'settings.successful': 'Erfolgreich',
  'settings.testPrint': 'Testdruck',
  'settings.testPrintHeader': 'Testdruck-Kopfzeile',
  'settings.testPrinted': 'Testdruck durchgeführt',
  'settings.turkey': 'Türkei',
  'settings.webSerialNotSupported': 'Web Serial nicht unterstützt',
  'settings.webSerialSupported': 'Web Serial unterstützt',

  // Registrierung
  'signup.companyDetails': 'Unternehmensdetails',
  'signup.errors.companyCodeRequired': 'Unternehmenskennung erforderlich',
  'signup.errors.companyCodeTooShort': 'Unternehmenskennung zu kurz',
  'signup.errors.companyNameRequired': 'Unternehmensname erforderlich',
  'signup.errors.emailInvalid': 'Ungültige E-Mail-Adresse',
  'signup.errors.emailRequired': 'E-Mail erforderlich',
  'signup.errors.ownerNameRequired': 'Inhabername erforderlich',
  'signup.errors.signupFailed': 'Registrierung fehlgeschlagen',
  'signup.fields.companyCode': 'Unternehmenskennung',
  'signup.fields.companyName': 'Unternehmensname',
  'signup.fields.country': 'Land',
  'signup.fields.email': 'E-Mail',
  'signup.fields.ownerName': 'Inhabername',
  'signup.fields.phone': 'Telefon',
  'signup.haveAccount': 'Haben Sie bereits ein Konto?',
  'signup.placeholders.companyCode': 'Unternehmenskennung eingeben...',
  'signup.placeholders.companyName': 'Unternehmensname eingeben...',
  'signup.placeholders.email': 'E-Mail eingeben...',
  'signup.placeholders.ownerName': 'Inhabername eingeben...',
  'signup.placeholders.phone': 'Telefon eingeben...',
  'signup.referral.bonus': 'Empfehlungsbonus',
  'signup.referral.title': 'Einladungscode',

  // Status
  'status.cancelled': 'Storniert',
  'status.delivered': 'Geliefert',
  'status.pending': 'Ausstehend',
  'status.pickup_in_progress': 'Abholung läuft',
  'status.pickup_pending': 'Abholung ausstehend',
  'status.ready': 'Bereit',
  'status.received': 'Erhalten',

  // Abonnement
  'subscription.buyNow': 'Jetzt kaufen',
  'subscription.cancel': 'Abonnement kündigen',
  'subscription.contactSales': 'Vertrieb kontaktieren',
  'subscription.contactSupport': 'Support kontaktieren',
  'subscription.currentPlan': 'Aktueller Plan',
  'subscription.currentUsage': 'Aktuelle Nutzung',
  'subscription.daysLeft': 'verbleibende Tage',
  'subscription.downgrade': 'Downgrade',
  'subscription.endDate': 'Enddatum',
  'subscription.expired': 'Abgelaufen',
  'subscription.expiredOn': 'Abgelaufen am',
  'subscription.expiresOn': 'Läuft ab am',
  'subscription.features': 'Funktionen',
  'subscription.loading': 'Abonnement wird geladen...',
  'subscription.monthly': 'Monatlich',
  'subscription.monthlyLimit': 'Monatliches Limit',
  'subscription.noSubscription': 'Kein aktives Abonnement',
  'subscription.payNow': 'Jetzt bezahlen',
  'subscription.plan': 'Plan',
  'subscription.popular': 'Beliebt',
  'subscription.pro': 'Pro',
  'subscription.renew': 'Verlängern',
  'subscription.renewNow': 'Jetzt verlängern',
  'subscription.startDate': 'Startdatum',
  'subscription.trial': 'Testphase',
  'subscription.trialDaysLeft': 'verbleibende Testtage',
  'subscription.trialEnd': 'Testphase endet',
  'subscription.upgrade': 'Upgrade',
  'subscription.yearly': 'Jährlich',

  // Änderungsschneiderei
  'tailoring.addCustom': 'Benutzerdefiniert hinzufügen',
  'tailoring.astarDegisimi': 'Futtertausch',
  'tailoring.belAyarı': 'Taillenverstellung',
  'tailoring.cancel': 'Abbrechen',
  'tailoring.cepDikimi': 'Taschennaht',
  'tailoring.dugmeDikme': 'Knopf annähen',
  'tailoring.fermuarDegisimi': 'Reißverschlusstausch',
  'tailoring.icon': 'Symbol',
  'tailoring.kolBoyu': 'Ärmellänge',
  'tailoring.omuzAyarı': 'Schulterverstellung',
  'tailoring.operationName': 'Vorgangsname',
  'tailoring.pacaBoyu': 'Hosenbeinlänge',
  'tailoring.price': 'Preis',
  'tailoring.save': 'Speichern',
  'tailoring.sokukDikimi': 'Saumnaht',
  'tailoring.yama': 'Flicken',

  // Support-Tickets
  'tickets.closed': 'Geschlossen',
  'tickets.translationError': 'Übersetzungsfehler',

  // Toast-Meldungen
  'toast.logoTooLarge': 'Logo-Datei ist zu groß',
  'toast.logoUploadError': 'Logo konnte nicht hochgeladen werden',
  'toast.uploadingLogo': 'Logo wird hochgeladen...',

  // WhatsApp
  'whatsapp.buyCredits': 'Credits kaufen',
  'whatsapp.connect': 'WhatsApp verbinden',
  'whatsapp.connected': 'Verbunden',
  'whatsapp.creditPackages': 'Credit-Pakete',
  'whatsapp.credits': 'Credits',
  'whatsapp.creditsRemaining': 'verbleibende Credits',
  'whatsapp.disconnect': 'Trennen',
  'whatsapp.messages': 'Nachrichten',
  'whatsapp.noCredits': 'Keine Credits verfügbar',
  'whatsapp.orderDelivered': 'Bestellung geliefert',
  'whatsapp.orderReady': 'Bestellung bereit',
  'whatsapp.preview': 'Vorschau',
  'whatsapp.receiptCreated': 'Quittung erstellt',
  'whatsapp.save': 'Vorlage speichern',
  'whatsapp.saved': 'Vorlage gespeichert',
  'whatsapp.scanQR': 'QR-Code scannen',
  'whatsapp.sendTest': 'Testnachricht senden',
  'whatsapp.status': 'Status',
  'whatsapp.template': 'Vorlage',
  'whatsapp.templates': 'Vorlagen',
  'whatsapp.testFailed': 'Testnachricht fehlgeschlagen',
  'whatsapp.testSent': 'Testnachricht gesendet',

  // Z-Bericht
  'zReport.byEmployee': 'Nach Mitarbeiter',
  'zReport.byProduct': 'Nach Produkt',
  'zReport.byService': 'Nach Dienst',
  'zReport.cardPayments': 'Kartenzahlungen',
  'zReport.cashIn': 'Einnahmen',
  'zReport.cashOut': 'Ausgaben',
  'zReport.cashPayments': 'Barzahlungen',
  'zReport.closingBalance': 'Abschlusssaldo',
  'zReport.creditPayments': 'Kreditzahlungen',
  'zReport.custom': 'Benutzerdefiniert',
  'zReport.daily': 'Täglich',
  'zReport.endDate': 'Enddatum',
  'zReport.free': 'Kostenlos',
  'zReport.freeOrders': 'Kostenlose Bestellungen',
  'zReport.generateReport': 'Bericht erstellen',
  'zReport.monthly': 'Monatlich',
  'zReport.newCustomers': 'Neue Kunden',
  'zReport.openingBalance': 'Eröffnungssaldo',
  'zReport.printReport': 'Bericht drucken',
  'zReport.returningCustomers': 'Wiederkehrende Kunden',
  'zReport.selectDate': 'Datum auswählen',
  'zReport.serviceBreakdown': 'Dienstaufschlüsselung',
  'zReport.startDate': 'Startdatum',
  'zReport.title': 'Z-Bericht',
  'zReport.totalCollected': 'Gesamt eingezogen',
  'zReport.totalItems': 'Gesamte Artikel',
  'zReport.totalOrders': 'Gesamte Bestellungen',
  'zReport.totalRefunds': 'Gesamte Rückerstattungen',
  'zReport.totalRevenue': 'Gesamtumsatz',
  'zReport.transferPayments': 'Überweisungen',
  'zReport.weekly': 'Wöchentlich',
  'zreport.card': 'Karte',
  'zreport.cash': 'Bar',
  'zreport.date': 'Datum',
  'zreport.orders': 'Bestellungen',
  'zreport.print': 'Drucken',
  'zreport.title': 'Z-Bericht',
  'zreport.total': 'Gesamt',

  'zReport.cashBoxStartNote': 'Kassenbestand zu Beginn',
  'zReport.todayCashNote': 'Heute erhaltenes Bargeld',
  'zReport.branchCollectionsNote': 'Eigene + andere Filialeinnahmen',
  'zReport.dailyExpensesNote': 'Tagesausgaben',
  'customerCard.balanceZero': 'Guthaben ist bereits null.',
  'customerCard.debtLabel': 'Schulden werden gelöscht',
  'customerCard.creditLabel': 'Guthaben wird gelöscht',
  'customerCard.resetConfirm': 'Guthaben wird zurückgesetzt ({label}). Bestätigen?',
  'customerCard.resetSuccess': 'Guthaben zurückgesetzt',
  'customerCard.resetError': 'Guthaben konnte nicht zurückgesetzt werden',
  'customerCard.printTitle': 'Kundenkarte',
  'customerCard.heading': 'KUNDENKARTE',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'ADRESSE',
  'customerCard.printButton': 'Kundenkarte drucken',
  'customerCard.resetting': 'Wird zurückgesetzt...',
  'customerCard.resetBalance': 'Guthaben zurücksetzen',
  'tailoring.loadError': 'Preise konnten nicht geladen werden',
  'tailoring.nameRequired': 'Bitte geben Sie einen Operationsnamen ein',
  'tailoring.invalidPrice': 'Bitte geben Sie einen gültigen Preis ein',
  'tailoring.addSuccess': 'Neuer Schneidervorgang hinzugefügt!',
  'tailoring.saveError': 'Speicherfehler',
  'tailoring.deleteConfirm': 'Sind Sie sicher, dass Sie diesen Vorgang löschen möchten?',
  'tailoring.deleteSuccess': 'Vorgang gelöscht',
  'tailoring.deleteError': 'Löschfehler',
  'tailoring.saveSuccess': 'Schneiderpreise gespeichert!',
  'tailoring.addNewTitle': 'Neuen Schneidervorgang hinzufügen',
  'tailoring.operationNameLabel': 'Vorgangsname',
  'tailoring.priceLabel': 'Preis',
  'tailoring.iconLabel': 'Symbol (Emoji)',
  'tailoring.operationNamePlaceholder': 'z.B. Kragennaht',
  'tailoring.savePricesHint': 'Klicken Sie auf Speichern, um die Preise zu speichern',
  'tailoring.addCustomHint': 'Verwenden Sie die + Schaltfläche für benutzerdefinierte Vorgänge',
  'reportsList.title': 'Quittungsliste',
  'reportsList.startDate': 'Startdatum',
  'reportsList.endDate': 'Enddatum',
  'reportsList.search': 'Suchen',
  'reportsList.loading': 'Wird geladen...',
  'reportsList.description': 'Alle in diesem Zeitraum erfassten oder gelieferten Quittungen werden aufgelistet',
  'reportsList.empty': 'Keine Quittungen in diesem Zeitraum gefunden',
  'reportsList.changeDateRange': 'Wählen Sie einen anderen Zeitraum',
  'reportsList.categoryBreakdown': 'Aufschlüsselung nach Kategorie',
  'reportsList.unknown': 'Unbekannt',
  'reportsList.cancelReason': 'Stornierungsgrund:',
  'reportsList.excelDownloaded': 'Excel-Datei heruntergeladen',
  'reportsList.excelError': 'Excel-Datei konnte nicht erstellt werden',
  'reportsList.totalReceipt': 'Quittungen gesamt',
  'reportsList.activeReceipt': 'Aktive Quittungen',
  'reportsList.loadError': 'Quittungsliste konnte nicht geladen werden',
  'reportsList.dateError': 'Startdatum darf nicht nach Enddatum liegen',
  'charts.revenue': 'Umsatz',
  'charts.orders': 'Bestellungen',
  'charts.pieces': 'Stückanzahl',
  'charts.receipts': 'Quittungsanzahl',
  'charts.loadError': 'Daten konnten nicht geladen werden',

  'customerStatement.selectDateRange': 'Datumsbereich auswählen',
  'customerStatement.thisMonth': 'Diesen Monat',
  'customerStatement.lastMonth': 'Letzten Monat',
  'customerStatement.allTime': 'Alle Zeiten',
  'customerStatement.startDate': 'Startdatum',
  'customerStatement.endDate': 'Enddatum',
  'customerStatement.printPDF': 'Kontoauszug drucken (PDF)',
  'customerStatement.title': 'KONTOAUSZUG',
  'customerStatement.customerName': 'Kundenname',
  'customerStatement.phone': 'Telefon',
  'customerStatement.address': 'Adresse',
  'customerStatement.openingBalance': 'Eröffnungssaldo',
  'customerStatement.closingBalance': 'Abschlusssaldo',
  'customerStatement.description': 'Beschreibung',
  'customerStatement.type': 'Typ',
  'customerStatement.debit': 'Soll',
  'customerStatement.credit': 'Haben (eingezogen)',
  'customerStatement.total': 'GESAMT',
  'customerStatement.cancelled': 'STORNIERT',
  'customerStatement.payment': 'Zahlung',
  'customerStatement.items': 'Artikel',
  'customerStatement.noTransactions': 'Keine Transaktionen im ausgewählten Zeitraum.',
  'customerStatement.statementDate': 'Auszugsdatum',

  'tailoring.subtitle': 'Hier können Sie die Preise für Schneiderarbeiten aktualisieren',
  'tailoring.addNewDescription': 'Eine benutzerdefinierte Schneidervorgangsart hinzufügen',
  'tailoring.add': 'Hinzufügen',
  'tailoring.savePrices': 'Preise speichern',
  'tailoring.default': 'Standard',
  'tailoring.infoTitle': 'Information',
  'tailoring.info1': 'Klicken Sie nach der Preisänderung auf "Preise speichern"',
  'tailoring.info2': 'Mit "Neuer Vorgang" können Sie benutzerdefinierte Schneidervorgangsarten hinzufügen',
  'tailoring.info3': 'Benutzerdefinierte Vorgänge können mit dem Papierkorbsymbol gelöscht werden',
  'tailoring.info4': 'Diese Preise werden beim Erstellen von Bestellungen mit Schneiderservice verwendet',
  'tailoring.info5': 'Sie können für jeden Schneidervorgang einen separaten Preis festlegen',
  'tailoring.info6': 'Preise werden beim Hinzufügen zum Warenkorb automatisch berechnet',

  'hardware.title': 'Hardware-Shop',
  'hardware.subtitle': 'Bon-Drucker, Etikettendrucker und Caller-ID-Geräte',
  'hardware.cart': 'Warenkorb',
  'hardware.infoTitle': 'Information',
  'hardware.infoText': 'Diese Hardware-Produkte sind derzeit nur in der Türkei erhältlich. Für andere Länder sind sie nur zu Informationszwecken aufgeführt.',
  'hardware.myCart': 'Mein Warenkorb',
  'hardware.cartEmpty': 'Warenkorb leer',
  'hardware.vatSuffix': '+ MwSt.',
  'hardware.total': 'Gesamt',
  'hardware.checkout': 'Zur Kasse',
  'hardware.receiptPrinters': 'Bon-Drucker',
  'hardware.receiptPrintersSubtitle': '80mm Thermodrucker mit Automatikschneider',
  'hardware.compatibilityTitle': 'CleandySoft Kompatibilität',
  'hardware.receiptCompatText': 'Funktioniert mit allen 80mm Thermodruckern mit Automatikschneider.',
  'hardware.labelPrinters': 'Etikettendrucker',
  'hardware.labelPrintersSubtitle': 'Nadeldrucker, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Getestete Modelle',
  'hardware.labelCompatText': 'Getestet für Epson TM-U220 und Bixolon SRP-270. Andere Marken oder Modelle können Probleme haben.',
  'hardware.callerIdTitle': 'Anrufer-ID-Geräte',
  'hardware.callerIdSubtitle': 'Anrufererkennung für Kundengespräche',
  'hardware.compatibilityNote': 'Kompatibilitätshinweis',
  'hardware.callerIdCompatText': 'Nur für CIDShow 2-Zeilen-Modell getestet. Andere Marken oder Modelle können funktionieren, sind aber nicht garantiert.',
  'hardware.barcodeScanners': 'Barcode-Scanner',
  'hardware.barcodeScannerSubtitle': 'USB-Barcode- und QR-Code-Scanner',
  'hardware.barcodeCompatText': 'Alle 2D-Barcode-Scanner können mit CleandySoft verwendet werden. Scanner im USB-HID-Modus werden automatisch unterstützt.',
  'hardware.driverDownloads': 'Treiber & Software-Downloads',
  'hardware.driverDownloadsText': 'Es wird empfohlen, den entsprechenden Treiber herunterzuladen, bevor Sie den Drucker anschließen.',
  'hardware.onlyTurkey': 'Dieses Produkt ist nur in der Türkei erhältlich',
  'hardware.addedToCart': 'Zum Warenkorb hinzugefügt!',
  'hardware.available': 'Verfügbar',
  'hardware.info': 'Info',
  'hardware.features': 'Funktionen',
  'hardware.addToCart': 'In den Warenkorb',
  'hardware.infoOnly': 'Nur zur Information',

  // Payment dialog
  'payment.amountToPay': 'Zu zahlender Betrag',
  'payment.remaining': 'Restbetrag',
  'payment.cash': 'Bar',
  'payment.creditCard': 'Kreditkarte (POS)',
  'payment.account': 'Kundenkonto',
  'payment.onDelivery': 'Bei Abholung',
  'payment.splitPayment': 'Geteilte Zahlung',
  'payment.mealCard': 'Essensgutschein',
  'payment.amount': 'Zahlungsbetrag',
  'payment.enterAmount': 'Zahlungsbetrag eingeben',
  'payment.madePayments': 'Geleistete Zahlungen',
  'subscription.referralDesc': 'Wenn sich ein eingeladener Freund registriert und Mitglied wird, erhältst du 1 Monat extra! Nur eine Einladung zu senden reicht nicht.',
};
